// import React, { useEffect, useState } from "react";
// import "stylesheets/createProject.scss";
// import { FaCheckCircle } from "react-icons/fa";
// import Button from "components/button";
// import InputBox from "components/comman/InputBox";
// import SelectBox from "components/comman/SelectBox";
// import { useForm } from "react-hook-form";
// import * as yup from "yup";
// import { yupResolver } from "@hookform/resolvers/yup";
// import RadioGroup from "components/comman/RadioGroup";
// import { IoClose } from "react-icons/io5";
// import { Images } from "constants/Images";
// import DataTable from "react-data-table-component";
// import CheckboxGroup from "components/comman/CheckboxGroup";
// import { FaAngleDown } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { IoLocation } from "react-icons/io5";
// import { IoMdCheckmark } from "react-icons/io";
// import { BiGridAlt } from "react-icons/bi";
// import { MdOutlineFastfood } from "react-icons/md";
// import { useLocation, useNavigate } from "react-router-dom";
// import AddFixtureModal from "components/modal/AddFixtureModal";
// import ModalC from "components/comman/ModalC";
// import { InlineEditor } from "components/InlineEditor";
// import { API } from "API/API";
// import { useAuthContext } from "context/auth/AuthContext";
// import { ClipLoader } from "react-spinners";

// const serveWare = [
//   { label: "Paper plates and plastic utensils", value: "false", type: "noflatware" },
//   // { label: "Silverware and glassware", value: "true", type: "withflatware" },
//   { label: "With Flatware", value: "true", type: "withflatware" },
// ]

// // const GreaseProductionCosts = {
// //   medium: {
// //     withflatware: 0.0455,    // High_Grease_Production_With_Flatware
// //     noflatware: 0.035        // High_Grease_Production_No_Flatware
// //   },
// //   high: {
// //     withflatware: 0.075,     // Very_High_Grease_Production_With_Flatware
// //     noflatware: 0.058        // Very_High_Grease_Production_No_Flatware
// //   }
// // };

// const GreaseProductionCosts = {
//   low: {
//     noflatware: 0.005,
//     withflatware: 0.0065,
//   },
//   medium: {
//     noflatware: 0.025,
//     withflatware: 0.325,
//   },
//   high: {
//     noflatware: 0.035,
//     withflatware: 0.0455,
//   },
//   very_high: {
//     noflatware: 0.058,
//     withflatware: 0.75,
//   },
// };

// const generateRandomKey = (length = 4) => {
//   const chars =
//     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
//   let key = "";
//   for (let i = 0; i < length; i++) {
//     key += chars.charAt(Math.floor(Math.random() * chars.length));
//   }
//   return key;
// };

// // const tabList = [
// //   { label: "About" },
// //   { label: "Location" },
// //   { label: "Fixtures" },
// //   { label: "Grease Capacity" },
// //   { label: "Summary" },
// // ];

// const typeList = [
//   // {
//   //   id: generateRandomKey(),
//   //   value: "",
//   //   name: "Select",
//   // },
//   {
//     id: generateRandomKey(),
//     value: "newConstruction",
//     name: "New Construction",
//   },
//   {
//     id: generateRandomKey(),
//     value: "tenantFinish",
//     name: "Remodel / Tenant Finish",
//   },
//   {
//     id: generateRandomKey(),
//     value: "shell",
//     name: "Shell Space (Unknown Tenant)",
//   },
//   {
//     id: generateRandomKey(),
//     value: "interceptorReplacement",
//     name: "Interceptor Replacement",
//   },
// ];


// const US_STATES = [
//   // { id: generateRandomKey(), value: "", name: "Select" },
//   { id: generateRandomKey(), value: "AL", name: "Alabama" },
//   { id: generateRandomKey(), value: "AK", name: "Alaska" },
//   { id: generateRandomKey(), value: "AZ", name: "Arizona" },
//   { id: generateRandomKey(), value: "AR", name: "Arkansas" },
//   { id: generateRandomKey(), value: "CA", name: "California" },
//   { id: generateRandomKey(), value: "CO", name: "Colorado" },
//   { id: generateRandomKey(), value: "CT", name: "Connecticut" },
//   { id: generateRandomKey(), value: "DE", name: "Delaware" },
//   { id: generateRandomKey(), value: "DC", name: "District of Columbia" },
//   { id: generateRandomKey(), value: "FL", name: "Florida" },
//   { id: generateRandomKey(), value: "GA", name: "Georgia" },
//   { id: generateRandomKey(), value: "GU", name: "Guam" },
//   { id: generateRandomKey(), value: "HI", name: "Hawaii" },
//   { id: generateRandomKey(), value: "ID", name: "Idaho" },
//   { id: generateRandomKey(), value: "IL", name: "Illinois" },
//   { id: generateRandomKey(), value: "IN", name: "Indiana" },
//   { id: generateRandomKey(), value: "IA", name: "Iowa" },
//   { id: generateRandomKey(), value: "KS", name: "Kansas" },
//   { id: generateRandomKey(), value: "KY", name: "Kentucky" },
//   { id: generateRandomKey(), value: "LA", name: "Louisiana" },
//   { id: generateRandomKey(), value: "ME", name: "Maine" },
//   { id: generateRandomKey(), value: "MD", name: "Maryland" },
//   { id: generateRandomKey(), value: "MA", name: "Massachusetts" },
//   { id: generateRandomKey(), value: "MI", name: "Michigan" },
//   { id: generateRandomKey(), value: "MN", name: "Minnesota" },
//   { id: generateRandomKey(), value: "MS", name: "Mississippi" },
//   { id: generateRandomKey(), value: "MO", name: "Missouri" },
//   { id: generateRandomKey(), value: "MT", name: "Montana" },
//   { id: generateRandomKey(), value: "NE", name: "Nebraska" },
//   { id: generateRandomKey(), value: "NV", name: "Nevada" },
//   { id: generateRandomKey(), value: "NH", name: "New Hampshire" },
//   { id: generateRandomKey(), value: "NJ", name: "New Jersey" },
//   { id: generateRandomKey(), value: "NM", name: "New Mexico" },
//   { id: generateRandomKey(), value: "NY", name: "New York" },
//   { id: generateRandomKey(), value: "NC", name: "North Carolina" },
//   { id: generateRandomKey(), value: "ND", name: "North Dakota" },
//   { id: generateRandomKey(), value: "OH", name: "Ohio" },
//   { id: generateRandomKey(), value: "OK", name: "Oklahoma" },
//   { id: generateRandomKey(), value: "OR", name: "Oregon" },
//   { id: generateRandomKey(), value: "PA", name: "Pennsylvania" },
//   { id: generateRandomKey(), value: "PR", name: "Puerto Rico" },
//   { id: generateRandomKey(), value: "RI", name: "Rhode Island" },
//   { id: generateRandomKey(), value: "SC", name: "South Carolina" },
//   { id: generateRandomKey(), value: "SD", name: "South Dakota" },
//   { id: generateRandomKey(), value: "TN", name: "Tennessee" },
//   { id: generateRandomKey(), value: "TX", name: "Texas" },
//   { id: generateRandomKey(), value: "UT", name: "Utah" },
//   { id: generateRandomKey(), value: "VT", name: "Vermont" },
//   { id: generateRandomKey(), value: "VA", name: "Virginia" },
//   { id: generateRandomKey(), value: "WA", name: "Washington" },
//   { id: generateRandomKey(), value: "WV", name: "West Virginia" },
//   { id: generateRandomKey(), value: "WI", name: "Wisconsin" },
//   { id: generateRandomKey(), value: "WY", name: "Wyoming" },
// ];


// const CA_PROVINCES = [
//   // { id: generateRandomKey(), value: "", name: "Select" },
//   { id: generateRandomKey(), value: "BC", name: "British Columbia" },
//   { id: generateRandomKey(), value: "ON", name: "Ontario" },
//   { id: generateRandomKey(), value: "NL", name: "Newfoundland and Labrador" },
//   { id: generateRandomKey(), value: "NS", name: "Nova Scotia" },
//   { id: generateRandomKey(), value: "PE", name: "Prince Edward Island" },
//   { id: generateRandomKey(), value: "NB", name: "New Brunswick" },
//   { id: generateRandomKey(), value: "QC", name: "Quebec" },
//   { id: generateRandomKey(), value: "MB", name: "Manitoba" },
//   { id: generateRandomKey(), value: "SK", name: "Saskatchewan" },
//   { id: generateRandomKey(), value: "AB", name: "Alberta" },
//   { id: generateRandomKey(), value: "NT", name: "Northwest Territories" },
//   { id: generateRandomKey(), value: "NU", name: "Nunavut" },
//   { id: generateRandomKey(), value: "YT", name: "Yukon Territory" },
// ];


// const STATE_OPTIONS = {
//   US: US_STATES,
//   CA: CA_PROVINCES,
// };



// const stateList = [
//   {
//     id: generateRandomKey(),
//     value: "",
//     name: "Select",
//   },
//   {
//     id: generateRandomKey(),
//     value: "AL",
//     name: "Alabama",
//   },
//   {
//     id: generateRandomKey(),
//     value: "AK",
//     name: "Alaska",
//   },
//   {
//     id: generateRandomKey(),
//     value: "AZ",
//     name: "Arizona",
//   },
//   {
//     id: generateRandomKey(),
//     value: "AR",
//     name: "Arkansas",
//   },
// ];
// const countryList = [
//   // {
//   //   id: generateRandomKey(),
//   //   value: "",
//   //   name: "Select",
//   // },
//   {
//     id: generateRandomKey(),
//     value: "US",
//     name: "United States",
//   },
//   {
//     id: generateRandomKey(),
//     value: "CA",
//     name: "Canada",
//   },
// ];

// const insideLocationList = [
//   // {
//   //   id: generateRandomKey(),
//   //   value: "",
//   //   name: "Select",
//   // },
//   {
//     id: generateRandomKey(),
//     value: "kitchen",
//     name: "Kitchen",
//   },
//   {
//     id: generateRandomKey(),
//     value: "inBasement",
//     name: "In Basement",
//   },
//   {
//     id: generateRandomKey(),
//     value: "parkingGarage",
//     name: "Parking Garage",
//   },
//   {
//     id: generateRandomKey(),
//     value: "suspendedPenetratingFloor",
//     name: "Suspended / Penetrating Floor",
//   },
//   {
//     id: generateRandomKey(),
//     value: "otherLocation",
//     name: "Other Location",
//   },
// ];

// const mealList = [
//   {
//     id: generateRandomKey(),
//     title: "Meals per day",
//     label: "Meals per day",
//     value: 0,
//     data: "",
//     perDay: "",
//     calculation: (value) => value, // Direct value
//   },
// ];



// const stepOneSchema = yup.object({
//   typeSelect: yup.string().required().label("Construction Type"),
//   projectName: yup.string().required().label("Facility/Project Name"),
//   streetAddress: yup.string().optional(),
//   city: yup.string().required().label("City"),
//   // county: yup.string().optional(),
//   state: yup.string().required().label("State/Region"),
//   zipCode: yup.string().optional(),
//   country: yup.string().required().label("Country"),
//   note: yup.string().optional(),
// });

// const stepTwoSchema = yup.object({
//   capacityType: yup.string().required().label("Capacity Type"),
//   interceptorType: yup.string().required().label("Interceptor Type"),
//   trapLocation: yup.string().required().label("Trap Location"),
//   insideLocation: yup.string().when('trapLocation', {
//     is: 'indoors',
//     then: yup.string().required().label("Where Inside"),
//     otherwise: yup.string().optional()
//   }),
//   buried: yup.string().required().label("Buried"),
//   pumpOutIncluded: yup.string().when('trapLocation', {
//     is: 'indoors',
//     then: yup.string().required().label("Pump Out Included"),
//     otherwise: yup.string().optional()
//   }),
//   installedInTraffic: yup.string().when(['trapLocation', 'buried'], {
//     is: (trapLocation, buried) => trapLocation === 'indoors' && buried === 'yes',
//     then: yup.string().required().label("Installed in Traffic"),
//     otherwise: yup.string().optional()
//   }),
//   accuracy: yup.string().required().label("Efficiency Compliance"),
//   solidInterceptorRequired: yup.string().required().label("Solid Interceptor Required"),
// });


// const stepThreeSchema = yup.object({
//   // pipeSize: yup.string().required().label("Pip Size"),
//   pipeSize: yup.string().optional().label("Pipe Size"),
// });
// const stepFourSchema = yup.object({
//   appliances: yup
//     .array()
//     .of(yup.string())
//     .min(1, "Please select at least one appliance")
//     .required("Please select at least one appliance"),
//   flatware: yup.string().required().label("Flat ware"),

//   bestDescribe: yup.string().required("Best describe is required"),
//   mealType: yup.object().shape({
//     type: yup.string().required("Meal type is required"),
//     value: yup
//       .number()
//       .typeError("Value must be a number")
//       .required("Value is required"),
//   }),
//   sqfBuilding: yup.number().typeError("Square feet is required").positive("Must be a positive number").required("Square feet is required"),
//   diningAreaPercentage: yup.number().typeError("Percentage is required").positive("Must be a positive number").max(100, "Cannot exceed 100").required("Percentage is required"),
//   sqfPerPerson: yup.number().typeError("SQF/Person is required").positive("Must be a positive number").required("SQF/Person is required"),
//   turnsPerSeat: yup.number().typeError("Turns per seat is required").positive("Must be a positive number").required("Turns per seat is required"),
//   pumpOutCycle: yup.string().required("Pump Out Cycle is required")
// });

// const transformStepOneData = (formData) => {
//   return {
//     step: 1,
//     constructionType: formData.typeSelect,
//     projectName: formData.projectName,
//     address: {
//       street: formData.streetAddress || "",
//       country: formData.country,
//       state: formData.state,
//       city: formData.city,
//       zip: formData.zipCode || ""
//     },
//     authorityHavingJurisdiction: formData.note || "",
//     representative: formData.representative || ""
//   };
// };

// // Transform Step 2 form data to API format
// const transformStepTwoData = (formData) => {
//   return {
//     step: 2,
//     interceptorType: formData.interceptorType,
//     greeceInterceptorLocation: formData.trapLocation,
//     willBurried: formData.buried === "yes",
//     insideArea: formData.insideLocation || "",
//     isInstallPort: formData.pumpOutIncluded === "yes",
//     willInstallVehichleTrafficArea: formData.installedInTraffic === "yes",
//     accuracy: formData.accuracy === "yes",
//     materialType: formData.capacityType,
//     solidInterceptorRequired: formData.solidInterceptorRequired === "yes",
//   };
// };

// // Transform form data for step 3
// const transformStepThreeData = (formData, fixtures) => {
//   return {
//     step: 3,
//     drainagePipeSize: formData.pipeSize ? parseFloat(formData.pipeSize) : "",
//     fixtures: fixtures.map(fixture => ({
//       fixtureType: fixture.fixtureType,
//       fixtureName: fixture.fixtureName,
//       trapSize: fixture.trapSize,
//       dfuType: fixture.dfuType,
//       dfuValue: parseFloat(fixture.dfuValue) || 0,
//       gpm: fixture.gpm || "",
//       quantity: parseInt(fixture.quantity) || 1,
//       flowRate: fixture.flowRate || "",
//       included: fixture.included !== false, // default to true
//       ...(fixture.fixtureType === "custom_sink" ? {
//         dimensions: {
//           length: fixture.length,
//           width: fixture.width,
//           depth: fixture.depth,
//           compartments: fixture.compartments
//         }
//       } : {})
//     }))
//   };
// };

// const transformStepFourData = (formData, selectMenu, calculatedMeals, calculatedGreaseCost, selectedServeWare, extraData) => {
//   return {
//     step: 4,
//     kitchenAppliances: formData.appliances, // Array of appliances
//     servingWare: selectedServeWare.label, // String
//     menu: selectMenu?.title || "", // String: menu type name
//     menuValue: calculatedMeals || 0, // Number: calculated meals per day
//     lbs: calculatedGreaseCost || 0, // Number: calculated grease cost (LPS value)
//     sqfBuilding: extraData?.sqfBuilding || "",
//     diningAreaPercentage: extraData?.diningAreaPercentage || "",
//     sqfPerPerson: extraData?.sqfPerPerson || "",
//     turnsPerSeat: extraData?.turnsPerSeat || "",
//     pumpOutCycle: extraData?.pumpOutCycle || ""
//   };
// };

// const reverseTransformStepOneData = (apiData) => {
//   if (!apiData) return {};

//   // Handle the nested step1 structure from API response
//   const step1Data = apiData.step1 || apiData;

//   return {
//     typeSelect: step1Data.constructionType || "",
//     projectName: step1Data.projectName || "",
//     streetAddress: step1Data.address?.street || "",
//     city: step1Data.address?.city || "",
//     state: step1Data.address?.state || "",
//     zipCode: step1Data.address?.zip || "",
//     country: step1Data.address?.country || "US",
//     note: step1Data.authorityHavingJurisdiction || "",
//     representative: step1Data.representative || ""
//   };
// };

// const reverseTransformStepTwoData = (apiData) => {
//   if (!apiData) return {};

//   // Handle the nested step2 structure from API response
//   const step2Data = apiData.step2 || apiData;

//   return {
//     interceptorType: step2Data.interceptorType || "",
//     trapLocation: step2Data.greeceInterceptorLocation || "indoors",
//     buried: step2Data.willBurried ? "yes" : "no",
//     capacityType: step2Data.materialType || "",
//     insideLocation: step2Data.insideArea || "",
//     pumpOutIncluded: step2Data.isInstallPort ? "yes" : "no",
//     installedInTraffic: step2Data.willInstallVehichleTrafficArea ? "yes" : "no",
//     accuracy: step2Data.accuracy ? "yes" : "no",
//     solidInterceptorRequired: step2Data.solidInterceptorRequired ? "yes" : "no",

//   };
// };


// const reverseTransformStepThreeData = (apiData) => {
//   if (!apiData) return { pipeSize: "2", fixtures: [] };

//   // Handle the nested step3 structure from API response
//   const step3Data = apiData.step3 || apiData;

//   const fixtures = (step3Data.fixtures || []).map(fixture => ({
//     id: generateRandomKey(),
//     included: fixture.included !== false,
//     fixtureType: fixture.fixtureType || "",
//     fixtureName: fixture.fixtureName || "",
//     trapSize: fixture.trapSize || "",
//     dfuType: fixture.dfuType || "",
//     dfuValue: fixture.dfuValue || "",
//     gpm: fixture.gpm || "",
//     length: fixture.dimensions?.length || "",
//     width: fixture.dimensions?.width || "",
//     depth: fixture.dimensions?.depth || fixture.dimensions?.height || "",
//     compartments: fixture.dimensions?.compartments || "",
//     quantity: String(fixture.quantity || 1),
//     flowRate: fixture.flowRate || ""
//   }));

//   return {
//     pipeSize: step3Data.drainagePipeSize || "4",
//     fixtures: fixtures
//   };
// };

// const reverseTransformStepFourData = (apiData, menuList = []) => {
//   if (!apiData) return {};

//   // Handle the nested step4 structure from API response
//   const step4Data = apiData.step4 || apiData;

//   // Check if selectedMenu already exists in the response (when coming from Step 5)
//   let matchedMenu = step4Data.selectedMenu;
//   let matchedServeWare = step4Data.selectedServeWare;

//   // If not, try to find matches from the raw data
//   if (!matchedMenu && step4Data.menu) {
//     matchedMenu = menuList.find(menu => menu.title === step4Data.menu);
//   }

//   if (!matchedServeWare && step4Data.servingWare) {
//     matchedServeWare = serveWare.find(ware => ware.label === step4Data.servingWare);
//   }

//   // Get the meal data that was selected
//   let selectedMealData = step4Data.selectedMealData;

//   // If selectedMealData is null but we have mealType data, find the matching meal data
//   if (!selectedMealData && step4Data.mealType && step4Data.mealType.type) {
//     selectedMealData = mealList.find(meal => meal.title === step4Data.mealType.type);
//   }

//   // Fallback: if still no selectedMealData, default to first meal type
//   if (!selectedMealData) {
//     selectedMealData = mealList.find(meal => meal.title === "Meals per day");
//   }

//   return {
//     appliances: step4Data.appliances || step4Data.kitchenAppliances || [],
//     flatware: matchedServeWare?.value || step4Data.flatware || "true",
//     bestDescribe: matchedMenu?.title || step4Data.bestDescribe || step4Data.menu || "",
//     selectedMenu: matchedMenu,
//     selectedServeWare: matchedServeWare,
//     calculatedMeals: step4Data.calculatedMeals || step4Data.menuValue || 0,
//     calculatedGreaseCost: step4Data.calculatedGreaseCost || step4Data.lps || 0,
//     selectedMealData: selectedMealData,
//     mealType: {
//       type: selectedMealData?.title || "Meals per day",
//       value: step4Data.calculatedMeals || step4Data.menuValue || 0
//     },
//     sqfBuilding: step4Data.sqfBuilding || "",
//     diningAreaPercentage: step4Data.diningAreaPercentage || "",
//     sqfPerPerson: step4Data.sqfPerPerson || "",
//     turnsPerSeat: step4Data.turnsPerSeat || "",
//     pumpOutCycle: step4Data.pumpOutCycle || ""
//   };
// };


// const StepOne = ({ onNext, loading, setLoading, setProjectId, token, existingData, projectId }) => {

//   const { handleSubmit, control, setValue, getValue, watch, reset } = useForm({
//     resolver: yupResolver(stepOneSchema),
//     defaultValues: {
//       country: "US",
//       state: "",
//     },

//   });

//   const selectedCountry = watch("country");


//   const stateSelectList =
//     selectedCountry && STATE_OPTIONS[selectedCountry]
//       ? STATE_OPTIONS[selectedCountry]
//       : [{ id: generateRandomKey(), value: "", name: "Select" }];

//   //       React.useEffect(() => {
//   //   setValue("state", "");
//   // }, [selectedCountry, setValue]);

//   const handleBtn = async (formData) => {


//     setLoading(true);
//     try {
//       // Transform form data to API format
//       const apiData = transformStepOneData(formData);


//       let response;

//       if (projectId) {
//         // Update existing project
//         response = await API.updateCalculatorConfiguration(projectId, apiData, token);

//       } else {
//         // Create new project
//         response = await API.createCalculatorConfiguration(apiData, token);

//       }

//       // Check if response is successful
//       if (response && response.success) {
//         // Store the project ID for subsequent steps (only for create)
//         if (!projectId && response.data?.configurationId) {
//           setProjectId(response.data.configurationId);
//         }

//         toast.success(response.message || "Project information saved successfully!");
//         onNext();
//       } else {
//         toast.error(response?.message || "Failed to save project information. Please try again.");
//       }
//     } catch (error) {
//       toast.error("An error occurred while saving project information. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (existingData) {
//       const formData = reverseTransformStepOneData(existingData);
//       reset(formData);

//     }
//   }, [existingData, reset]);

//   return (
//     <div className="stepWrap">
//       <div className="stepWrap__ttl">
//         <h2>Interceptor Information</h2>
//         <span>ASME Sizing Guidelines</span>
//       </div>
//       <div className="stepWrap__type">
//         <div className="half">
//           <SelectBox
//             control={control}
//             name="typeSelect"
//             label="Building Description: *"
//             selectList={typeList}
//           />
//         </div>
//       </div>
//       <div className="row">
//         <div className="col-6">
//           <InputBox
//             label="Name of Project *"
//             name="projectName"
//             control={control}
//           />
//         </div>
//         <div className="col-6">
//           <InputBox
//             label="Address"
//             name="streetAddress"
//             control={control}
//           />
//         </div>

//         <div className="col-3">
//           <SelectBox
//             label="Country *"
//             name="country"
//             selectList={countryList}
//             control={control}
//           />
//         </div>
//         <div className="col-3">
//           <SelectBox
//             label="State / Province *"
//             name="state"
//             // selectList={stateList}
//             selectList={stateSelectList}
//             control={control}
//           //            onChange={(val) => {
//           //           setValue("country", val);
//           //           setValue("state", "");
//           // }}
//           />
//         </div>

//         {/* <div className="col-3">
//           <InputBox label="County" name="county" control={control} />
//         </div> */}
//         <div className="col-3">
//           <InputBox label="City *" name="city" control={control} />
//         </div>
//         <div className="col-3">
//           <InputBox label="Zip / Area Code" name="zipCode" control={control} />
//         </div>
//       </div>
//       <div className="row">
//         {/* <div className="col-6">
//           <SelectBox
//             label="Country *"
//             name="country"
//             selectList={countryList}
//             control={control}
//           />
//         </div> */}
//       </div>
//       <div className="row">

//         <div className="col-6">
//           <InputBox
//             label="Name of Engineer / AJH - Authority Having Jurisdiction"
//             name="note"
//             control={control}
//           />
//         </div>
//       </div>
//       <div className="stepWrap__cta">

//         <Button label={loading ? "Saving..." : "Continue"} onClick={handleSubmit(handleBtn)} disabled={loading} />

//       </div>
//     </div>
//   );
// };

// const PumpOutPort = ({ show, onClose }) => {
//   return (
//     <div className={`pump ${show ? "show" : null}`}>
//       <div className="pump__header">
//         <h4>Pumpout Port {show ? "show" : null}</h4>
//         <button type="button" onClick={onClose}>
//           <IoClose />
//         </button>
//       </div>
//       <div className="pump__body">
//         <div className="img">
//           <img src="/images/pump-img.png" alt="" />
//           <p>
//             A pumpout port provides remote access for pumping and eliminates the
//             need for unsanitary pumper equipment inside the building. Before
//             answering the question, review the installation instructions to
//             understand installation needs.
//           </p>
//         </div>
//         <div className="row">
//           <div className="col-6">
//             <div className="imgWrap">
//               <img src="/images/pump-pp1.png" alt="" />
//               <h5>PP1</h5>
//               <a href="https://schierproducts.com/shop/pp1" target="_blank">
//                 View
//               </a>
//             </div>
//           </div>
//           <div className="col-6">
//             <div className="imgWrap">
//               <img src="/images/pump-pp2.png" alt="" />
//               <h5>PP3</h5>
//               <a href="https://schierproducts.com/shop/pp3" target="_blank">
//                 View
//               </a>
//             </div>
//           </div>
//         </div>
//         <div className="cta">
//           <Button label="Got IT" onClick={onClose} />
//         </div>
//       </div>
//     </div>
//   );
// };



// // const StepTwo = ({ onPrev, onNext, loading, setLoading, projectId, token, existingData, loadStepData, onCapacityTypeChange, capacityList, setCapacityList }) => {
// const StepTwo = ({ onPrev, onNext, loading, setLoading, projectId, token, existingData, loadStepData, onCapacityTypeChange, onInterceptorTypeChange, capacityList, setCapacityList }) => {
//   const [pumpOut, setPumpOut] = useState();
//   const { handleSubmit, control, setValue, getValue, watch, reset } = useForm({
//     resolver: yupResolver(stepTwoSchema),
//     defaultValues: {
//       capacityType: "",
//       interceptorType: "",
//       trapLocation: "inside",
//       buried: "no",
//       accuracy: "no",
//       solidInterceptorRequired: "no",
//     },
//   });

//   const handleBtn = async (formData) => {


//     if (!projectId) {
//       toast.error("Project ID not found. Please restart the process from Step 1.");
//       return;
//     }

//     setLoading(true);
//     try {
//       const apiData = transformStepTwoData(formData);


//       const response = await API.updateCalculatorConfiguration(projectId, apiData, token);


//       if (response && response.success) {
//         toast.success(response.message || "Location information saved successfully!");
//         onNext();
//       } else {
//         toast.error(response?.message || "Failed to save location information. Please try again.");
//       }
//     } catch (error) {

//       toast.error("An error occurred while saving location information. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const selectedTrapLocation = watch("trapLocation");
//   const selectedBuried = watch("buried");

//   const onPumpOut = () => {
//     setPumpOut(!pumpOut);
//     if (pumpOut) {
//       document.body.style.overflow = "auto";
//     } else {
//       document.body.style.overflow = "hidden";
//     }
//   };

//   const handlePrevious = async () => {
//     await loadStepData(1, true);
//     onPrev();
//   };



//   useEffect(() => {
//     if (existingData) {
//       const formData = reverseTransformStepTwoData(existingData);
//       reset(formData);

//     }
//   }, [existingData, reset]);

//   const selectedInterceptorType = watch("interceptorType");

//   useEffect(() => {
//     if (selectedInterceptorType && onInterceptorTypeChange) {
//       onInterceptorTypeChange(selectedInterceptorType);
//     }
//   }, [selectedInterceptorType]);


//   const selectedCapacityType = watch("capacityType");

//   // Add this useEffect inside StepTwo
//   useEffect(() => {
//     if (selectedCapacityType && capacityList?.length > 0) {
//       const found = capacityList.find(item => item?.value === selectedCapacityType);
//       if (found && onCapacityTypeChange) {
//         // Map the name to a display label
//         const name = found.name?.toLowerCase() || "";
//         if (name.includes("liquid")) {
//           onCapacityTypeChange("Liquid Capacity");
//         } else if (name.includes("sludge")) {
//           onCapacityTypeChange("Sludge Capacity");
//         } else {
//           onCapacityTypeChange(found.name || "Grease Capacity");
//         }
//       }
//     }
//   }, [selectedCapacityType, capacityList]);



//   return (
//     <div className="stepWrap">
//       <div className="stepWrap__ttl">
//         <h2>Interceptor Installation</h2>
//         <span>ASME Sizing Guidelines</span>
//       </div>

//       {/* 2-Column Layout */}
//       <div className="row">
//         {/* Left Column */}
//         <div className="col-6">
//           <SelectBox
//             label="Material Type *"
//             name="capacityType"
//             selectList={capacityList}
//             control={control}
//           />
//           <RadioGroup
//             name="accuracy"
//             control={control}
//             defaultValue="no"
//             label="Does the Interceptor need 99% grease efficiency? *"
//             options={[
//               { label: "Yes", value: "yes" },
//               { label: "No", value: "no" },
//             ]}
//             rules={{ required: "Please select efficiency compliance." }}
//           />
//           <RadioGroup
//             name="buried"
//             control={control}
//             defaultValue="no"
//             label="Is the Interceptor buried in the ground? *"
//             options={[
//               { label: "Yes", value: "yes" },
//               { label: "No", value: "no" },
//             ]}
//             rules={{ required: "Please select buried option." }}
//           />
//           <RadioGroup
//             name="solidInterceptorRequired"
//             control={control}
//             defaultValue="no"
//             label="Do you require Solid Interceptor? *"
//             options={[
//               { label: "Yes", value: "yes" },
//               { label: "No", value: "no" },
//             ]}
//             rules={{ required: "Please select solid interceptor option." }}
//           />
//         </div>

//         {/* Right Column */}
//         <div className="col-6">
//           <RadioGroup
//             name="interceptorType"
//             control={control}
//             defaultValue=""
//             label="Interceptor Type *"
//             options={[
//               { label: "Hydromechanical", value: "hydromechanical" },
//               { label: "Gravity", value: "gravity" },
//             ]}
//             rules={{ required: "Please select an interceptor type." }}
//           />
//           <RadioGroup
//             name="trapLocation"
//             control={control}
//             defaultValue="inside"
//             label="Location of Interceptor?"
//             options={[
//               { label: "Inside", value: "inside" },
//               { label: "Outside", value: "outside" },
//             ]}
//             rules={{ required: "Please select a trap location." }}
//           />
//           {selectedTrapLocation === "inside" && (
//             <SelectBox
//               label="Where inside? *"
//               name="insideLocation"
//               selectList={insideLocationList}
//               control={control}
//             />
//           )}
//           {selectedTrapLocation === "inside" && (
//             <RadioGroup
//               name="pumpOutIncluded"
//               control={control}
//               defaultValue="yes"
//               label="Install a port to allow for remote pumpout of the tank? *"
//               options={[
//                 { label: "Yes", value: "yes" },
//                 { label: "No", value: "no" },
//               ]}
//               rules={{ required: "Please select pump out option." }}
//             />
//           )}
//           {selectedTrapLocation === "inside" && selectedBuried === "yes" && (
//             <RadioGroup
//               name="installedInTraffic"
//               control={control}
//               defaultValue="yes"
//               label="Will it be installed in a vehicle traffic area? *"
//               options={[
//                 { label: "Yes", value: "yes" },
//                 { label: "No", value: "no" },
//               ]}
//               rules={{ required: "Please select traffic area option." }}
//             />
//           )}
//         </div>
//       </div>

//       <div className="stepWrap__cta">
//         <Button white label="Previous" onClick={handlePrevious} />
//         <Button
//           label={loading ? "Saving..." : "Continue"}
//           onClick={handleSubmit(handleBtn)}
//         />
//       </div>
//     </div>
//   );
// };


// const StepThree = ({ onPrev, onNext, loading, setLoading, projectId, token, existingData, loadStepData, capacityTypeLabel }) => {
//   const [fixtures, setFixtures] = useState([]);
//   const [editingRowId, setEditingRowId] = useState(null);
//   const [editForm, setEditForm] = useState({
//     included: true,
//     fixtureType: "",
//     fixtureName: "",
//     trapSize: "",
//     dfuType: "", // "private" or "public"
//     dfuValue: "",
//     gpm: "",
//     length: "",
//     width: "",
//     depth: "",
//     compartments: "",
//     quantity: 1,
//     flowRate: ""
//   });

//   const [deleteIndex, setDeleteIndex] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [isAddingNew, setIsAddingNew] = useState(false);
//   const [fixtureTypesList, setFixtureTypesList] = useState([]);
//   const [isLoadingFixtures, setIsLoadingFixtures] = useState(true);

//   const { handleSubmit, control, reset } = useForm({
//     resolver: yupResolver(stepThreeSchema),
//     defaultValues: { pipeSize: "4" }
//   });



//   useEffect(() => {
//     const fetchFixtureTypes = async () => {
//       setIsLoadingFixtures(true);
//       try {
//         const response = await API.fetchListingDataFixture();

//         if (response && response?.success && response?.data) {
//           const transformedFixtures = response?.data?.map(fixture => ({
//             id: generateRandomKey(),
//             value: fixture?.name,
//             name: fixture?.name,
//             trapSize: fixture?.trapSize || "",
//             privateDfu: fixture?.privateDfu ? parseFloat(fixture.privateDfu) : null,
//             publicDfu: fixture?.publicDfu ? parseFloat(fixture.publicDfu) : null,
//           }));
//           transformedFixtures.push({
//             id: generateRandomKey(),
//             value: "other",
//             name: "Other (Manual Entry)",
//             trapSize: "",
//             privateDfu: null,
//             publicDfu: null,
//           });
//           transformedFixtures.push({
//             id: generateRandomKey(),
//             value: "custom_sink",
//             name: "Custom",
//             trapSize: "",
//             privateDfu: null,
//             publicDfu: null,
//           });

//           setFixtureTypesList(transformedFixtures);
//         } else {
//           toast.error("Failed to load fixture types");
//           setFixtureTypesList([]);
//         }
//       } catch (error) {
//         toast.error("Error loading fixture types from server");
//         setFixtureTypesList([]);
//       } finally {
//         setIsLoadingFixtures(false);
//       }
//     };

//     fetchFixtureTypes();

//   }, []);

//   // Get DFU options for selected fixture
//   // const getDfuOptions = (fixtureType) => {
//   //   const fixture = fixtureTypesList.find(f => f.value === fixtureType);
//   //   if (!fixture) return [];

//   //   const options = [];
//   //   if (fixture.privateDfu !== null && fixture.privateDfu !== undefined) {
//   //     options.push({ id: generateRandomKey(), value: "private", name: `Private: ${fixture.privateDfu}` });
//   //   }
//   //   if (fixture.publicDfu !== null && fixture.publicDfu !== undefined) {
//   //     options.push({ id: generateRandomKey(), value: "public", name: `Public: ${fixture.publicDfu}` });
//   //   }
//   //   return options;
//   // };

//   const getDfuOptions = (fixtureType) => {
//     const fixture = fixtureTypesList.find(f => f.value === fixtureType);
//     if (!fixture) return [];

//     const options = [];
//     if (fixture.privateDfu !== null && fixture.privateDfu !== undefined) {
//       options.push({ id: generateRandomKey(), value: "private", name: "Private" });
//     }
//     if (fixture.publicDfu !== null && fixture.publicDfu !== undefined) {
//       options.push({ id: generateRandomKey(), value: "public", name: "Public" });
//     }
//     return options;
//   };

//   const beginEdit = (row) => {
//     setEditingRowId(row.id);
//     setEditForm({
//       included: row.included ?? true,
//       fixtureType: row.fixtureType || "",
//       fixtureName: row.fixtureName || "",
//       trapSize: row.trapSize || "",
//       dfuType: row.dfuType || "",
//       dfuValue: row.dfuValue || "",
//       gpm: row.gpm || "",
//       length: row.length || "",
//       width: row.width || "",
//       depth: row.depth || "",
//       compartments: row.compartments || "",
//       quantity: parseInt(row.quantity || 1, 10),
//       flowRate: row.flowRate || ""
//     });
//   };

//   const cancelEdit = () => {
//     setEditingRowId(null);
//     setIsAddingNew(false);
//     setEditForm({
//       included: true,
//       fixtureType: "",
//       fixtureName: "",
//       trapSize: "",
//       dfuType: "",
//       dfuValue: "",
//       gpm: "",
//       length: "",
//       width: "",
//       depth: "",
//       compartments: "",
//       quantity: 1,
//       flowRate: ""
//     });
//   };

//   const saveEdit = (data) => {
//     if (isAddingNew) {
//       const id = generateRandomKey();

//       const newRow = {
//         id,
//         included: data.included,
//         fixtureType: data.fixtureType,
//         fixtureName: data.fixtureName,
//         trapSize: data.trapSize,
//         dfuType: data.dfuType,
//         dfuValue: data.dfuValue,
//         gpm: data.gpm,
//         length: data.length,
//         width: data.width,
//         depth: data.depth,
//         compartments: data.compartments,
//         quantity: String(data.quantity),
//         flowRate: data.flowRate
//       };

//       setFixtures(prev => [...prev, newRow]);
//       setIsAddingNew(false);
//     } else {
//       setFixtures(prev =>
//         prev.map(item => {
//           if (item.id !== editingRowId) return item;
//           return {
//             ...item,
//             included: data.included,
//             fixtureType: data.fixtureType,
//             fixtureName: data.fixtureName,
//             trapSize: data.trapSize,
//             dfuType: data.dfuType,
//             dfuValue: data.dfuValue,
//             gpm: data.gpm,
//             length: data.length,
//             width: data.width,
//             depth: data.depth,
//             compartments: data.compartments,
//             quantity: String(data.quantity),
//             flowRate: data.flowRate
//           };
//         })
//       );
//     }
//     setEditingRowId(null);
//   };

//   const addNewRowAndEdit = () => {
//     setIsAddingNew(true);
//     setEditingRowId(null);
//     setEditForm({
//       included: true,
//       fixtureType: "",
//       fixtureName: "",
//       trapSize: "",
//       dfuType: "",
//       dfuValue: "",
//       gpm: "",
//       length: "",
//       width: "",
//       depth: "",
//       compartments: "",
//       quantity: 1,
//       flowRate: ""
//     });
//   };

//   const handleDeleteClick = (e, row) => {
//     e.preventDefault();
//     const index = fixtures.findIndex(f => f.id === row.id);
//     setDeleteIndex(index);
//     setShowDeleteModal(true);
//   };

//   const handleEdit = (e, row) => {
//     e.preventDefault();
//     setIsAddingNew(false);
//     beginEdit(row);
//   };

//   const handleQuantityChange = (increment) => {

//     setEditForm(prev => ({
//       ...prev,
//       quantity: Math.max(1, prev.quantity + increment)
//     }));
//   };

//   // const onChangeEditForm = (patch) =>
//   //   setEditForm(prev => ({ ...prev, ...patch }));
//   const onChangeEditForm = (patch) => {
//     setEditForm(prev => ({
//       ...prev,  // Keep all existing fields
//       ...patch  // Only update the changed fields
//     }));
//   };

//   const onChangeFixtureType = (value) => {
//     // ✅ ADD THIS: Handle "Other" option
//     if (value === "other" || value === "custom_sink") {
//       // Clear all fields for manual entry
//       setEditForm(prev => ({
//         ...prev,
//         fixtureType: value,
//         fixtureName: value === "custom_sink" ? "Custom" : "",
//         trapSize: "",
//         gpm: "",
//         dfuType: "",
//         dfuValue: "",
//         length: "",
//         width: "",
//         depth: "",
//         compartments: "",
//         flowRate: ""
//       }));
//       return; // Exit early
//     }

//     // ✅ EXISTING CODE: Handle predefined fixtures
//     const selected = fixtureTypesList.find(f => f.value === value);

//     setEditForm(prev => ({
//       ...prev,
//       fixtureType: value,
//       fixtureName: selected ? selected.name : "",
//       trapSize: selected ? selected.trapSize : "",
//       gpm: selected ? selected.gpm : "",
//       dfuType: "",
//       dfuValue: "",
//       length: "",
//       width: "",
//       depth: "",
//       compartments: "",
//       flowRate: ""
//     }));
//   };



//   const onChangeDfuType = (value) => {
//     const fixture = fixtureTypesList.find(f => f.value === editForm.fixtureType);
//     let dfuValue = "";

//     if (fixture && value === "private") {
//       dfuValue = fixture.privateDfu;
//     } else if (fixture && value === "public") {
//       dfuValue = fixture.publicDfu;
//     }

//     setEditForm(prev => ({
//       ...prev,
//       dfuType: value,
//       dfuValue: dfuValue
//     }));
//   };

//   // Updated columns for the table
//   const columns = [
//     {
//       name: "Fixture Name",
//       selector: (row) => row.fixtureName,
//       cell: (row) => row?.fixtureName,
//     },
//     {
//       name: "Trap Size",
//       selector: (row) => row.trapSize,
//       cell: (row) => row?.trapSize ? `${row.trapSize}"` : "N/A",
//     },
//     {
//       name: "DFU Type",
//       selector: (row) => row.dfuType,
//       cell: (row) => row?.dfuType || "N/A",
//     },
//     {
//       name: "DFU Value",
//       selector: (row) => row.dfuValue,
//       cell: (row) => row?.dfuValue || "N/A",
//     },
//     {
//       name: "GPM",
//       selector: (row) => row.gpm,
//       cell: (row) => row?.gpm || "N/A",
//     },

//     {
//       name: "Quantity",
//       selector: (row) => row.quantity,
//       cell: (row) => row?.quantity,
//     },
//     {
//       name: "Flow Rate",
//       selector: (row) => row.flowRate,
//       cell: (row) => row?.flowRate ? `${row.flowRate} GPM` : "N/A",
//     },
//     {
//       name: "Actions",
//       selector: (row) => row.quantity,
//       cell: (row) => (
//         <ul className="tableCta">
//           <li>
//             <img
//               src={Images.icon.edit}
//               alt="edit"
//               onClick={(e) => handleEdit(e, row)}
//               style={{ cursor: "pointer" }}
//             />
//           </li>
//           <li>
//             <img
//               src={Images.icon.delete}
//               alt="delete"
//               onClick={(e) => handleDeleteClick(e, row)}
//               style={{ cursor: "pointer" }}
//             />
//           </li>
//         </ul>
//       ),
//     },
//   ];

//   const customSinkColumns = [
//     {
//       name: "Fixture Name",
//       selector: (row) => row.fixtureType,
//       cell: (row) => "Custom",
//     },
//     {
//       name: "Length (L)",
//       selector: (row) => row.length,
//       cell: (row) => row?.length,
//     },
//     {
//       name: "Width (W)",
//       selector: (row) => row.width,
//       cell: (row) => row?.width,
//     },
//     {
//       name: "Depth (D)",
//       selector: (row) => row.depth,
//       cell: (row) => row?.depth,
//     },
//     {
//       name: "Compartments (N)",
//       selector: (row) => row.compartments,
//       cell: (row) => row?.compartments,
//     },
//     {
//       name: "Flow Rate",
//       selector: (row) => row.flowRate,
//       cell: (row) => row?.flowRate ? `${row.flowRate} GPM` : "N/A",
//     },
//     {
//       name: "Actions",
//       cell: (row) => (
//         <ul className="tableCta">
//           <li>
//             <img
//               src={Images.icon.edit}
//               alt="edit"
//               onClick={(e) => handleEdit(e, row)}
//               style={{ cursor: "pointer" }}
//             />
//           </li>
//           <li>
//             <img
//               src={Images.icon.delete}
//               alt="delete"
//               onClick={(e) => handleDeleteClick(e, row)}
//               style={{ cursor: "pointer" }}
//             />
//           </li>
//         </ul>
//       ),
//     },
//   ];


//   const handleBtn = async (formData) => {


//     // Check if project ID exists
//     if (!projectId) {
//       toast.error("Project ID not found. Please restart the process from Step 1.");
//       return;
//     }

//     // Validate that at least one fixture is added
//     if (fixtures.length === 0) {
//       toast.error("Please add at least one fixture before continuing.");
//       return;
//     }

//     setLoading(true);
//     try {
//       // Transform form data to API format
//       const apiData = transformStepThreeData(formData, fixtures);


//       // Call API to update project
//       const response = await API.updateCalculatorConfiguration(projectId, apiData, token);


//       // Check if response is successful
//       if (response && response.success) {
//         toast.success(response.message || "Fixture information saved successfully!");
//         onNext();
//       } else {
//         toast.error(response?.message || "Failed to save fixture information. Please try again.");
//       }
//     } catch (error) {

//       toast.error("An error occurred while saving fixture information. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePrevious = async () => {
//     await loadStepData(2, true);
//     onPrev();
//   };

//   useEffect(() => {
//     if (existingData) {
//       const { pipeSize, fixtures: existingFixtures } = reverseTransformStepThreeData(existingData);
//       reset({ pipeSize });
//       setFixtures(existingFixtures);

//     }
//   }, [existingData, reset]);


//   return (
//     <div className="stepWrap">
//       <div className="stepWrap__ttl">
//         <h2>Connection Information</h2>
//         <span>ASME Sizing Guidelines</span>
//       </div>

//       <RadioGroup
//         name="pipeSize"
//         rows
//         control={control}
//         defaultValue="4"
//         label="Pipe size connected to the interceptor ?"
//         options={[
//           { label: `2"`, value: "2" },
//           { label: `3"`, value: "3" },
//           { label: `4"`, value: "4" },
//           { label: `6"`, value: "6" },
//           { label: `Don't Know`, value: "" },
//         ]}
//         rules={{ required: "Please select a trap location." }}
//       />

//       <div className="stepWrap__ttl" style={{ paddingTop: 30 }}>
//         <div className="form-group">
//           <h2>Fixtures ?</h2>
//           <label className="title">Tell us the fixtures used on this project</label>
//         </div>
//       </div>

//       {(fixtures.length === 0 || fixtures.filter(f => f.fixtureType !== "custom_sink").length > 0) && (
//         <div style={{ marginBottom: "30px" }}>
//           {fixtures.filter(f => f.fixtureType === "custom_sink").length > 0 && (
//             <h3 style={{ fontSize: "16px", marginBottom: "15px", fontWeight: "600", color: "#333" }}>Standard Fixtures</h3>
//           )}
//           <DataTable
//             keyField="id"
//             columns={columns}
//             data={fixtures.filter(f => f.fixtureType !== "custom_sink")}
//             pagination
//             expandableRows
//             expandableRowsHideExpander
//             expandableRowExpanded={(row) => row.id === editingRowId}
//             expandableRowsComponent={InlineEditor}
//             expandableRowsComponentProps={{
//               editForm,
//               fixtureTypesList,
//               onChangeEditForm,
//               onChangeFixtureType,
//               onChangeDfuType,
//               onQuantityChange: handleQuantityChange,
//               onCancel: cancelEdit,
//               onSave: saveEdit,
//               getDfuOptions
//             }}
//             onRowExpandToggled={(expanded, row) => {
//               if (!expanded && row.id === editingRowId) setEditingRowId(null);
//             }}
//           />
//         </div>
//       )}

//       {fixtures.filter(f => f.fixtureType === "custom_sink").length > 0 && (
//         <div style={{ marginBottom: "30px" }}>
//           <h3 style={{ fontSize: "16px", marginBottom: "15px", fontWeight: "600", color: "#333" }}>Custom</h3>
//           <DataTable
//             keyField="id"
//             columns={customSinkColumns}
//             data={fixtures.filter(f => f.fixtureType === "custom_sink")}
//             pagination
//             expandableRows
//             expandableRowsHideExpander
//             expandableRowExpanded={(row) => row.id === editingRowId}
//             expandableRowsComponent={InlineEditor}
//             expandableRowsComponentProps={{
//               editForm,
//               fixtureTypesList,
//               onChangeEditForm,
//               onChangeFixtureType,
//               onChangeDfuType,
//               onQuantityChange: handleQuantityChange,
//               onCancel: cancelEdit,
//               onSave: saveEdit,
//               getDfuOptions
//             }}
//             onRowExpandToggled={(expanded, row) => {
//               if (!expanded && row.id === editingRowId) setEditingRowId(null);
//             }}
//           />
//         </div>
//       )}

//       {/* Add New Fixture Form */}
//       {isAddingNew && (
//         <InlineEditor
//           editForm={editForm}
//           fixtureTypesList={fixtureTypesList}
//           onChangeEditForm={onChangeEditForm}
//           onChangeFixtureType={onChangeFixtureType}
//           onChangeDfuType={onChangeDfuType}
//           onQuantityChange={handleQuantityChange}
//           onCancel={cancelEdit}
//           onSave={saveEdit}
//           getDfuOptions={getDfuOptions}
//         />
//       )}

//       {!isAddingNew && (
//         <div className="addTable">
//           <button
//             type="button"
//             onClick={addNewRowAndEdit}
//             style={{ cursor: "pointer" }}
//           >
//             + ADD ANOTHER FIXTURE
//           </button>
//         </div>
//       )}

//       <div className="stepWrap__cta">
//         <Button white label="Previous" onClick={handlePrevious} />
//         <Button
//           label={loading ? "Saving..." : "Continue"}
//           onClick={handleSubmit(handleBtn)}
//           disabled={loading}
//         />

//       </div>

//       {showDeleteModal && (
//         <ModalC
//           title="Delete Fixture"
//           message="Are you sure you want to delete this fixture?"
//           showmodal={true}
//           handleClose={() => setShowDeleteModal(false)}
//           handleYes={() => {
//             setFixtures((prev) => prev.filter((_, i) => i !== deleteIndex));
//             setShowDeleteModal(false);
//             setDeleteIndex(null);
//             if (editingRowId && fixtures[deleteIndex]?.id === editingRowId) {
//               setEditingRowId(null);
//             }
//           }}
//         />
//       )}
//     </div>
//   );
// };




// const StepFour = ({ onPrev, onNext, loading, setLoading, projectId, token, existingData, loadStepData, capacityTypeLabel }) => {
//   const [selectMenu, setSelectMenu] = useState();
//   const [showMenu, setShowMenu] = useState();
//   const [mealData, setMealData] = useState();
//   const [showMeal, setShowMeal] = useState();
//   const [inputValue, setInputValue] = useState('');


//   const [calculatedGreaseCost, setCalculatedGreaseCost] = useState(0);
//   const [calculationBreakdown, setCalculationBreakdown] = useState('');

//   const initialServeWare = serveWare.find(item => item.value === "true");
//   const [selectedServeWare, setSelectedServeWare] = useState(initialServeWare);
//   const [calculatedMeals, setCalculatedMeals] = useState(0);
//   const [menuList, setMenuList] = useState([]);
//   const [isLoadingMenu, setIsLoadingMenu] = useState(true);
//   const { register, handleSubmit, control, setValue, getValues, watch, formState, reset } =
//     useForm({
//       resolver: yupResolver(stepFourSchema),
//       defaultValues: {
//         appliances: [],
//         sqfBuilding: '',
//         diningAreaPercentage: '',
//         sqfPerPerson: '',
//         turnsPerSeat: '',
//         pumpOutCycle: '',
//         mealType: {
//           type: 'Meals per day',
//           value: 0
//         }
//       }
//     });

//   const sqfBuilding = watch("sqfBuilding");
//   const diningAreaPercentage = watch("diningAreaPercentage");
//   const sqfPerPerson = watch("sqfPerPerson");
//   const turnsPerSeat = watch("turnsPerSeat");
//   const pumpOutCycle = watch("pumpOutCycle");

//   const selectedAppliances = watch("appliances") || [];

//   // Recalculate grease cost whenever any relevant variable changes
//   useEffect(() => {
//     if (selectMenu && selectedServeWare && calculatedMeals && pumpOutCycle) {
//       const prodRate = GreaseProductionCosts[selectMenu?.type]?.[selectedServeWare?.type?.toLowerCase()];
//       let calcValue = prodRate * calculatedMeals;

//       if (!isNaN(calcValue)) {
//         calcValue = calcValue * parseFloat(pumpOutCycle);

//         const hasFryer = selectedAppliances.includes("fryer");
//         const hasFoodWaste = selectedAppliances.includes("food_waste_disposal");

//         let breakdownStr = `${calculatedMeals} (Meals) × ${prodRate} (LBS) × ${pumpOutCycle} (Cycles)`;

//         if (hasFryer && hasFoodWaste) {
//           calcValue = calcValue / 0.67;
//           breakdownStr += ` ÷ 0.67 (Fryer & Food Waste)`;
//         } else if (hasFoodWaste && !hasFryer) {
//           calcValue = calcValue / 3;
//           breakdownStr += ` ÷ 3 (Food Waste Only)`;
//         }

//         setCalculatedGreaseCost(calcValue);
//         setCalculationBreakdown(breakdownStr);
//       }
//     } else {
//       setCalculatedGreaseCost(0);
//       setCalculationBreakdown('');
//     }
//   }, [calculatedMeals, selectMenu, selectedServeWare, pumpOutCycle, selectedAppliances]);

//   useEffect(() => {
//     const sqf = parseFloat(sqfBuilding);
//     const dining = parseFloat(diningAreaPercentage);
//     const perPerson = parseFloat(sqfPerPerson);
//     const turns = parseFloat(turnsPerSeat);

//     if (!isNaN(sqf) && !isNaN(dining) && !isNaN(perPerson) && perPerson > 0) {
//       const seats = ((sqf * dining) / 100) / perPerson;

//       if (!isNaN(turns)) {
//         const totalMeals = Math.round(seats * turns);
//         setInputValue(totalMeals.toString());
//         setValue("mealType.value", totalMeals, { shouldValidate: true });
//         setValue("mealType.type", "Meals per day", { shouldValidate: true });
//         setCalculatedMeals(totalMeals);
//       }
//     }
//   }, [sqfBuilding, diningAreaPercentage, sqfPerPerson, turnsPerSeat, mealData, setValue]);

//   const handlePrevious = async () => {
//     await loadStepData(3, true);
//     onPrev();
//   };


//   const handleBtn = async (formData) => {



//     // Check if project ID exists
//     if (!projectId) {
//       toast.error("Project ID not found. Please restart the process from Step 1.");
//       return;
//     }

//     // Validate required fields
//     // if (!selectMenu) {
//     //   toast.error("Please select a menu type before continuing.");
//     //   return;
//     // }

//     // if (!mealData || calculatedMeals === 0) {
//     //   toast.error("Please enter meal calculation details before continuing.");
//     //   return;
//     // }

//     setLoading(true);
//     try {
//       // Transform form data to API format
//       const apiData = transformStepFourData(formData, selectMenu, calculatedMeals, calculatedGreaseCost, selectedServeWare, {
//         sqfBuilding,
//         diningAreaPercentage,
//         sqfPerPerson,
//         turnsPerSeat,
//         pumpOutCycle
//       });



//       // Call API to update project
//       const response = await API.updateCalculatorConfiguration(projectId, apiData, token);


//       // Check if response is successful
//       if (response && response.success) {
//         toast.success(response.message || "Grease capacity information saved successfully!");
//         onNext();
//       } else {
//         toast.error(response?.message || "Failed to save grease capacity information. Please try again.");
//       }
//     } catch (error) {

//       toast.error("An error occurred while saving grease capacity information. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };




//   const handleInputChange = (e) => {
//     const value = parseFloat(e.target.value);
//     setInputValue(value);
//     setValue("mealType.value", value, { shouldValidate: true });
//     setValue("mealType.type", "Meals per day", { shouldValidate: true });

//     // Calculate meals per day based on selected meal type
//     let mealsPerDay = value; // Default to input value
//     if (mealData && mealData.calculation) {
//       mealsPerDay = mealData.calculation(value);
//     }
//     setCalculatedMeals(mealsPerDay);
//   };



//   const getCalculationDisplay = () => {
//     if (!mealData || !inputValue) return '';

//     switch (mealData.title) {
//       case "Number of Seats In Facility":
//         return `(${inputValue}) X 4 = ${Math.round(calculatedMeals)} meals per day`;
//       case "Square footage of facility":
//         return `((${inputValue}) X 0.6) / 14 X 4 = ${Math.round(calculatedMeals)} meals per day`;
//       default:
//         return `${Math.round(calculatedMeals)} meals per day`;
//     }
//   };


//   useEffect(() => {
//     if (existingData) {

//       const formData = reverseTransformStepFourData(existingData, menuList);


//       // Reset form with existing values
//       reset({
//         appliances: formData.appliances || [],
//         flatware: formData.flatware || "true",
//         bestDescribe: formData.bestDescribe || "",
//         mealType: formData.mealType || { type: "Meals per day", value: formData.calculatedMeals || 0 },
//         sqfBuilding: formData.sqfBuilding || '',
//         diningAreaPercentage: formData.diningAreaPercentage || '',
//         sqfPerPerson: formData.sqfPerPerson || '',
//         turnsPerSeat: formData.turnsPerSeat || '',
//         pumpOutCycle: formData.pumpOutCycle || ''
//       });

//       // Set state values
//       if (formData.selectedMenu) {
//         setSelectMenu(formData.selectedMenu);
//       }

//       // Set meal data - find the matching meal type
//       if (formData.selectedMealData) {
//         setMealData(formData.selectedMealData);
//       } else if (formData.mealType?.type) {
//         const foundMeal = mealList.find(meal => meal.title === formData.mealType.type);
//         setMealData(foundMeal || mealList[0]); // Default to first meal type if not found
//       } else {
//         setMealData(mealList[0]); // Default to "Meals per day"
//       }

//       // Set input value and calculated values
//       const mealValue = formData.mealType?.value || formData.calculatedMeals || 0;
//       setInputValue(mealValue.toString());

//       if (formData.selectedServeWare) {
//         setSelectedServeWare(formData.selectedServeWare);
//       }

//       if (formData.calculatedMeals) {
//         setCalculatedMeals(formData.calculatedMeals);
//       } else if (mealValue > 0) {
//         setCalculatedMeals(mealValue); // Use the meal value as calculated meals
//       }

//       if (formData.calculatedGreaseCost) {
//         setCalculatedGreaseCost(formData.calculatedGreaseCost);
//       }
//     }
//   }, [existingData, reset, menuList]);

//   useEffect(() => {
//     const fetchMenuItems = async () => {
//       setIsLoadingMenu(true);
//       try {
//         const response = await API.fetchListingDataMenuitems();

//         if (response && response?.success && response?.data) {
//           // ✅ Transform API data with correct field mapping
//           const transformedMenu = response?.data?.map(item => ({
//             title: item.name,
//             label: item.description,
//             type: item.tag,
//           }));

//           setMenuList(transformedMenu);

//         } else {
//           toast.error("Failed to load menu items");
//           setMenuList([]);
//         }
//       } catch (error) {
//         toast.error("Error loading menu items from server");
//         setMenuList([]);
//       } finally {
//         setIsLoadingMenu(false);
//       }
//     };

//     fetchMenuItems();
//   }, []);



//   return (
//     <div className="stepWrap">
//       <div className="stepWrap__ttl">
//         <h2>Grease Capacity Calculation</h2>
//         {/* <h2>Determining {capacityTypeLabel || "Capacity"}</h2> */}
//         <span>ASME Sizing Guidelines</span>
//       </div>
//       <div className="row">
//         <div className="col-6">
//           <CheckboxGroup
//             name="appliances"
//             label="What is in the kitchen? *"
//             control={control}
//             rules={{ required: "Please select at least one hobby" }}
//             options={[
//               { label: "Fryer", value: "fryer" },
//               { label: "Food Waste Disposal", value: "food_waste_disposal" },
//             ]}
//           />
//         </div>
//         <div className="col-6">
//           <RadioGroup
//             name="flatware"
//             control={control}
//             defaultValue="true"
//             label="What kind of dishes are used? *"
//             // options={[
//             //   { label: "Paper plates and plastic utensils", value: "false" },
//             //   { label: "Silverware and glassware", value: "true" },
//             // ]}
//             options={serveWare}
//             rules={{ required: "Please select a trap location." }}
//             onChange={(value) => {
//               const fullObject = serveWare.find(item => item.value === value);
//               setSelectedServeWare(fullObject);
//             }}
//           />

//         </div>
//         <div className="col-12">
//           <div className="form-group">
//             <label className="title">
//               What kind of restaurant is the interceptor serving? *
//             </label>
//             <div className="selectWrap">
//               <div
//                 className="form-control custom-select"
//                 style={selectMenu ? { fontWeight: "700" } : null}
//                 onClick={() => setShowMenu(!showMenu)}
//               >
//                 {selectMenu?.title || "Select"}
//               </div>
//               {showMenu && (
//                 <div className="dropdownMenu">
//                   {menuList?.map((item, idx) => (
//                     <div
//                       key={`menu__${idx}`}
//                       className={`dropdownMenu__item ${selectMenu === item ? "active" : null
//                         }`}
//                       onClick={() => {
//                         setSelectMenu(item);
//                         setShowMenu(false);
//                         setValue("bestDescribe", item.title);
//                       }}
//                     >
//                       <div className="head">
//                         <label>{item.title}</label>
//                         <small className={item.type}>{item.type} Grease</small>
//                       </div>
//                       {item.label && <span>{item.label}</span>}
//                     </div>
//                   ))}
//                 </div>
//               )}
//               {formState?.errors?.bestDescribe?.message && (
//                 <span className="error">
//                   {formState.errors.bestDescribe.message}
//                 </span>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className="col-12">
//           <div className="row" style={{ marginBottom: '15px' }}>
//             <div className="col-4">
//               <div className="form-group">
//                 <label className="title" style={{ fontSize: '14px', marginBottom: '8px' }}>Square Feet of building:</label>
//                 <input
//                   type="number"
//                   className="form-control"
//                   {...register("sqfBuilding")}
//                   placeholder="SQF value"
//                 />
//                 {formState?.errors?.sqfBuilding?.message && (
//                   <span className="error" style={{ display: 'block', marginTop: '5px' }}>
//                     {formState.errors.sqfBuilding.message}
//                   </span>
//                 )}
//               </div>
//             </div>
//             <div className="col-4">
//               <div className="form-group">
//                 <label className="title" style={{ fontSize: '14px', marginBottom: '8px' }}>Dining Area Percentage:</label>
//                 <input
//                   type="number"
//                   className="form-control"
//                   {...register("diningAreaPercentage")}
//                   placeholder="% Value"
//                 />
//                 {formState?.errors?.diningAreaPercentage?.message && (
//                   <span className="error" style={{ display: 'block', marginTop: '5px' }}>
//                     {formState.errors.diningAreaPercentage.message}
//                   </span>
//                 )}
//               </div>
//             </div>
//             <div className="col-4">
//               <div className="form-group">
//                 <label className="title" style={{ fontSize: '14px', marginBottom: '8px' }}>SQF/Person:</label>
//                 <input
//                   type="number"
//                   className="form-control"
//                   {...register("sqfPerPerson")}
//                   placeholder="People per SQF"
//                 />
//                 {formState?.errors?.sqfPerPerson?.message && (
//                   <span className="error" style={{ display: 'block', marginTop: '5px' }}>
//                     {formState.errors.sqfPerPerson.message}
//                   </span>
//                 )}
//               </div>
//             </div>
//           </div>
//           {(sqfBuilding && diningAreaPercentage && sqfPerPerson) ? (
//             <div className="form-group" style={{ marginTop: '-10px', marginBottom: '15px' }}>
//               <p style={{ margin: 0, fontSize: '14px', color: '#333' }}>
//                 Calculated Number of Seats: <b>{(((parseFloat(sqfBuilding) * parseFloat(diningAreaPercentage)) / 100) / parseFloat(sqfPerPerson)).toFixed(2)}</b>
//               </p>
//             </div>
//           ) : null}

//           <div className="row">
//             <div className="col-12">
//               <div className="form-group">
//                 <label className="title">Turns per seat:</label>
//                 <input
//                   type="number"
//                   className="form-control"
//                   {...register("turnsPerSeat")}
//                   placeholder="Turns per seat"
//                 />
//                 {formState?.errors?.turnsPerSeat?.message && (
//                   <span className="error" style={{ display: 'block', marginTop: '5px' }}>
//                     {formState.errors.turnsPerSeat.message}
//                   </span>
//                 )}
//               </div>
//             </div>
//           </div>
//           {(sqfBuilding && diningAreaPercentage && sqfPerPerson && turnsPerSeat) ? (
//             <div className="form-group" style={{ marginTop: '-10px', marginBottom: '15px' }}>
//               <p style={{ margin: 0, fontSize: '14px', color: '#333' }}>
//                 Calculated Total Meals: <b>{Math.round((((parseFloat(sqfBuilding) * parseFloat(diningAreaPercentage)) / 100) / parseFloat(sqfPerPerson)) * parseFloat(turnsPerSeat))}</b>
//               </p>
//             </div>
//           ) : null}

//           <div className="row">
//             <div className="col-12">
//               <div className="form-group">
//                 <label className="title">
//                   Please Select Sizing Method *
//                 </label>

//                 <div className="fieldGroup">
//                   <div className="customDropdown" style={{ cursor: 'default' }}>
//                     <button type="button" className="customDropdown__btn" style={{ background: '#f8f9fa', color: '#333', pointerEvents: 'none' }}>
//                       Meals per day
//                     </button>
//                   </div>
//                   <input
//                     type="number"
//                     className="form-control"
//                     value={inputValue}
//                     onChange={handleInputChange}
//                     placeholder="Enter meals per day"
//                   />
//                 </div>

//                 {formState?.errors?.mealType?.type?.message && (
//                   <span className="error">
//                     {formState.errors.mealType?.type?.message}
//                   </span>
//                 )}
//                 {formState?.errors?.mealType?.value?.message &&
//                   !formState?.errors?.mealType?.type?.message && (
//                     <span className="error">
//                       {formState.errors.mealType?.value?.message}
//                     </span>
//                   )}
//               </div>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-12">
//               <div className="form-group">
//                 <label className="title">Pump Out Cycles:</label>
//                 <select
//                   className="form-control"
//                   {...register("pumpOutCycle")}
//                 >
//                   <option value="" disabled>Please Select Pump Out Cycles:</option>
//                   <option value="30">30 Days</option>
//                   <option value="60">60 Days</option>
//                   <option value="90">90 Days</option>
//                 </select>
//                 {formState?.errors?.pumpOutCycle?.message && (
//                   <span className="error" style={{ display: 'block', marginTop: '5px' }}>
//                     {formState.errors.pumpOutCycle.message}
//                   </span>
//                 )}
//               </div>
//             </div>
//           </div>

//           {calculatedGreaseCost > 0 && (
//             <div className="row" style={{ marginTop: '20px' }}>
//               <div className="col-12">
//                 <div style={{ padding: '15px', background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '5px' }}>
//                   {/* {calculationBreakdown && (
//                     <p style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#666' }}>
//                       <b>Calculation:</b> {calculationBreakdown}
//                     </p>
//                   )} */}
//                   <h4 style={{ margin: 0 }}>
//                     Calculated Grease Capacity: <b>{calculatedGreaseCost.toFixed(2)} LBS</b>
//                   </h4>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       <div className="stepWrap__cta">
//         <Button white label="Previous" onClick={handlePrevious} disabled={loading} />
//         <Button
//           label={loading ? "Saving..." : "Continue"}
//           onClick={handleSubmit(handleBtn)}
//           disabled={loading}
//         />
//       </div>
//     </div>
//   );
// };

// const StepFive = ({ onPrev, onNext, loadStepData, stepData, projectId, token, capacityTypeLabel, isGravity }) => {
//   const [summaryData, setSummaryData] = useState({
//     step1: null,
//     step2: null,
//     step3: null,
//     step4: null
//   });
//   const [loading, setLoading] = useState(true);
//   const [hasLoaded, setHasLoaded] = useState(false);
//   const [createLoading, setCreateLoading] = useState(false);
//   const [matchedProducts, setMatchedProducts] = useState(null);
//   const [showResults, setShowResults] = useState(false);
//   const navigate = useNavigate();

//   // Use cached stepData if available, only make API calls if data is missing
//   useEffect(() => {
//     // Only run once when component mounts or projectId changes
//     if (hasLoaded && projectId) return;

//     const loadAllStepData = async () => {
//       if (!projectId) {
//         setLoading(false);
//         return;
//       }

//       setLoading(true);

//       try {
//         // Always load fresh data for Step 5 to ensure we have the latest information
//         const [step1Data, step2Data, step3Data, step4Data] = await Promise.all([
//           loadStepData(1, true), // forceRefresh = true
//           loadStepData(2, true), // forceRefresh = true
//           loadStepData(3, true), // forceRefresh = true
//           loadStepData(4, true)  // forceRefresh = true
//         ]);

//         setSummaryData({
//           step1: step1Data,
//           step2: step2Data,
//           step3: step3Data,
//           step4: step4Data
//         });


//         setHasLoaded(true); // Mark as loaded
//       } catch (error) {

//         toast.error("Failed to load project summary");

//         // Fallback to cached data if fresh load fails
//         if (stepData[1] && stepData[2] && stepData[3] && stepData[4]) {
//           setSummaryData({
//             step1: stepData[1],
//             step2: stepData[2],
//             step3: stepData[3],
//             step4: stepData[4]
//           });
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadAllStepData();
//   }, [projectId]); // Remove loadStepData and stepData from dependencies

//   // Calculate fixture summary
//   const getFixtureSummary = () => {
//     if (!summaryData.step3?.step3?.fixtures) {
//       return { count: 0, totalFlowRate: 0 };
//     }

//     const fixtures = summaryData.step3.step3.fixtures;
//     const count = fixtures.length;

//     // Calculate total flow rate
//     const totalFlowRate = fixtures.reduce((sum, fixture) => {
//       const flowRate = parseFloat(fixture.flowRate) || 0;
//       return sum + flowRate;
//     }, 0);

//     return { count, totalFlowRate };
//   };

//   // Get construction type from step 1
//   const getConstructionType = () => {
//     if (!summaryData.step1?.step1?.constructionType) {
//       return "Not specified";
//     }

//     const constructionType = summaryData.step1.step1.constructionType;
//     const typeMap = {
//       "newConstruction": "New Construction",
//       "tenantFinish": "Remodel / Tenant Finish",
//       "shell": "Shell Space (Unknown Tenant)",
//       "interceptorReplacement": "Interceptor Replacement"
//     };

//     return typeMap[constructionType] || constructionType;
//   };

//   // Get location information from step 2
//   const getLocationInfo = () => {
//     if (!summaryData.step2?.step2) {
//       return "Not specified";
//     }

//     const step2 = summaryData.step2.step2;
//     const location = step2.greeceInterceptorLocation === "indoors" ? "Indoors" : "Outdoors";
//     const buried = step2.willBurried ? "Buried" : "Not Buried";

//     return `${location}, ${buried}`;
//   };

//   // Get pipe connection info from step 3
//   const getPipeConnection = () => {
//     if (!summaryData.step3?.step3?.drainagePipeSize) {
//       return "Not specified";
//     }

//     return `${summaryData.step3.step3.drainagePipeSize}" Pipe`;
//   };

//   // Get grease capacity info from step 4
//   const getGreaseCapacity = () => {
//     if (!summaryData.step4?.step4) {
//       return { menu: "Not specified", menuValue: 0, lbs: 0 };
//     }

//     const step4 = summaryData.step4.step4;
//     return {
//       menu: step4.menu || "Not specified",
//       menuValue: step4.menuValue || 0,
//       lbs: step4.lbs || 0
//     };
//   };

//   const handlePrevious = async () => {
//     // No need to load data when going back
//     onPrev();
//   };



//   const handleCreateProject = async () => {
//     if (!projectId) {
//       toast.error("Project ID not found. Please restart the process from Step 1.");
//       return;
//     }

//     setCreateLoading(true);
//     try {
//       const response = await API.getMatchedProduct(projectId, token);

//       if (response && response.success) {
//         toast.success(response.message);

//         // Navigate to results page with the matched product data
//         navigate('/project-results', {
//           state: {
//             productId: response.data?.primaryProduct?._id,
//             secondaryProductId: response.data?.secondaryProduct?._id,
//             matchedProducts: response.data?.primaryProduct,
//             projectId: projectId,
//             projectAddress: summaryData.step1?.step1?.address ?
//               `${summaryData.step1.step1.address.street}, ${summaryData.step1.step1.address.city}, ${summaryData.step1.step1.address.state} ${summaryData.step1.step1.address.zip} ${summaryData.step1.step1.address.country}` :
//               "Address not available",
//             constructionType: summaryData.step1?.step1?.constructionType ?
//               getConstructionType() : "Not specified",
//             steponeDetails: summaryData.step1?.step1
//           }
//         });
//       } else {
//         toast.error(response?.message || "Failed to create project and find matched products.");
//       }
//     } catch (error) {

//       toast.error("An error occurred while creating the project. Please try again.");
//     } finally {
//       setCreateLoading(false);
//     }
//   };

//   const handleBackToSummary = () => {
//     setShowResults(false);
//     setMatchedProducts(null);
//   };

//   if (loading) {
//     return (
//       <div className="stepWrap">
//         <div className="stepWrap__ttl">
//           <div>
//             <h2>Gathering Requirement For Your Project</h2>
//             <p>We're reviewing the provided information...</p>
//           </div>
//         </div>
//         <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
//           <ClipLoader color="#38c4ac" size={50} />
//         </div>
//       </div>
//     );
//   }

//   const fixtureSummary = getFixtureSummary();
//   const constructionType = getConstructionType();
//   const locationInfo = getLocationInfo();
//   const pipeConnection = getPipeConnection();
//   const greaseCapacity = getGreaseCapacity();

//   return (
//     <div className="stepWrap">
//       <div className="stepWrap__ttl">
//         <div>
//           <h2>Gathering Requirement For Your Project</h2>
//           <p>We're reviewing the provided location information.</p>
//         </div>
//       </div>

//       <div className="row">
//         <div className={isGravity ? "col-6" : "col-4"}>
//           <div className="reviewBox">
//             <span><IoLocation /></span>
//             <h5>Interceptor Information</h5>
//             <ul>
//               <li><IoMdCheckmark /> {constructionType}</li>
//               <li><IoMdCheckmark /> {locationInfo}</li>
//             </ul>
//           </div>
//         </div>
//         <div className={isGravity ? "col-6" : "col-4"}>
//           <div className="reviewBox">
//             <span><BiGridAlt /></span>
//             <h5>Fixture Information</h5>
//             <ul>
//               <li><IoMdCheckmark /> {pipeConnection}</li>
//               <li>
//                 <IoMdCheckmark /> {fixtureSummary.count} Fixtures
//                 {fixtureSummary.totalFlowRate > 0 && (
//                   <small style={{ display: 'block', marginTop: '4px', color: '#666' }}>
//                     Total Flow Rate: {fixtureSummary.totalFlowRate.toFixed(2)} GPM
//                   </small>
//                 )}
//               </li>
//             </ul>
//           </div>
//         </div>
//         {!isGravity && (
//           <div className="col-4">
//             <div className="reviewBox">
//               <span><MdOutlineFastfood /></span>
//               <h5>{capacityTypeLabel || "Capacity"}</h5>
//               <ul>
//                 <li><IoMdCheckmark /> {greaseCapacity.menu}</li>
//                 <li>
//                   <IoMdCheckmark /> {greaseCapacity.menuValue} meals/day
//                   {greaseCapacity.lbs > 0 && (
//                     <small style={{ display: 'block', marginTop: '4px', color: '#666' }}>
//                       LBS: {greaseCapacity.lbs.toFixed(2)}
//                     </small>
//                   )}
//                 </li>
//               </ul>
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="stepWrap__cta">
//         <Button white label="Previous" onClick={handlePrevious} />
//         {/* <Button label="Create Project" onClick={onNext} /> */}
//         <Button
//           label={createLoading ? "Creating Project..." : "Create Project"}
//           onClick={handleCreateProject}
//           disabled={createLoading}
//         />
//       </div>
//     </div>
//   );
// };


// const CreateProjectForm = () => {
//   const [currentTabIndex, setCurrentTabIndex] = useState(0); // 👈 index instead of string
//   const [projectId, setProjectId] = useState(null);
//   const [stepData, setStepData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [completedSteps, setCompletedSteps] = useState([]);
//   const [formValidations, setFormValidations] = useState({
//     step1: false,
//     step2: false,
//     step3: false,
//     step4: false
//   });

//   const [capacityTypeLabel, setCapacityTypeLabel] = useState("Capacity");
//   const [capacityList, setCapacityList] = useState([]);

//   const [interceptorType, setInterceptorType] = useState("hydromechanical");



//   const isGravity = interceptorType === "gravity";

//   const TAB_INDICES = isGravity ? {
//     ABOUT: 0,
//     LOCATION: 1,
//     FIXTURES: 2,
//     SUMMARY: 3
//   } : {
//     ABOUT: 0,
//     LOCATION: 1,
//     FIXTURES: 2,
//     GREASE_CAPACITY: 3,
//     SUMMARY: 4
//   };

//   const tabList = isGravity ? [
//     { label: "About" },
//     { label: "Location" },
//     { label: "Fixtures" },
//     { label: "Summary" },
//   ] : [
//     { label: "About" },
//     { label: "Location" },
//     { label: "Fixtures" },
//     { label: capacityTypeLabel },
//     { label: "Summary" },
//   ];

//   const activeIndex = currentTabIndex;
//   const tabCount = tabList.length;
//   const progressWidth = ((activeIndex + 1) / tabCount) * 100;

//   const { state } = useLocation();
//   const { token: authToken } = useAuthContext();
//   const token = authToken || 'GUEST';

//   const canNavigateToStep = (stepIndex) => {
//     if (stepIndex < activeIndex) return true;
//     for (let i = 0; i < stepIndex; i++) {
//       if (!formValidations[`step${i + 1}`]) {
//         return false;
//       }
//     }
//     return true;
//   };

//   const updateFormValidation = (stepNumber, isValid) => {
//     setFormValidations(prev => ({
//       ...prev,
//       [`step${stepNumber}`]: isValid
//     }));
//   };

//   const loadStepData = async (step, forceRefresh = false) => {
//     if (!projectId) return null;
//     if (forceRefresh || !stepData[step]) {
//       try {
//         const response = await API.getCalculatorConfiguration(projectId, step, token);
//         if (response && response.success) {
//           setStepData(prev => ({ ...prev, [step]: response.data }));
//           return response.data;
//         } else {
//           return null;
//         }
//       } catch (error) {
//         toast.error(`Failed to load existing data for step ${step}`);
//         return null;
//       }
//     } else {
//       return stepData[step];
//     }
//   };



//   const getIndexFromTabName = (tabName) => {
//     const nameToIndex = {
//       "About": 0,
//       "Location": 1,
//       "Fixtures": 2,
//       "Grease Capacity": 3,
//       "Capacity": 3,
//       "Liquid Capacity": 3,
//       "Sludge Capacity": 3,
//       "Grease": 3,
//       "Lint": 3,
//       "Summary": 4
//     };
//     return nameToIndex[tabName] ?? 0;
//   };

//   useEffect(() => {
//     const fetchCapacity = async () => {
//       try {
//         // Same API call ProductPage uses for its Capacity filter
//         // let response = await API.ManufacturerListing(); // or whichever API serves capacity
//         let response = await API.ProductCategoryListing()
//         if (response?.data) {
//           const mapped = response?.data
//             ?.filter((item) => item?.status === 1)
//             ?.map((item) => ({
//               id: item?._id,
//               value: item?._id,
//               name: item?.title,
//             }));
//           setCapacityList(mapped);
//         }
//       } catch (error) {
//         toast.error("Failed to load capacity types");
//       }
//     };
//     if (capacityList.length === 0) {
//       fetchCapacity();
//     }
//   }, []);



//   useEffect(() => {
//     if (state?.data && state?.projectId) {
//       setProjectId(state.projectId);

//       // Convert string tab name to index safely 👇
//       if (state.targetTab) {
//         setCurrentTabIndex(getIndexFromTabName(state.targetTab));
//       }

//       if (state.configurationData) {
//         const config = state.configurationData;
//         const newStepData = {};
//         if (config.step1) newStepData[1] = config;
//         if (config.step2) newStepData[2] = config;
//         if (config.step3) newStepData[3] = config;
//         if (config.step4) newStepData[4] = config;
//         setStepData(newStepData);

//         const lastStep = parseInt(state.lastCompletedStep.replace('step', ''));
//         const newValidations = {};
//         for (let i = 1; i <= lastStep; i++) {
//           newValidations[`step${i}`] = true;
//         }
//         setFormValidations(newValidations);
//       }
//     }
//   }, [state]);

//   useEffect(() => {
//     if (!stepData[2]) return;
//     const step2 = stepData[2]?.step2 || stepData[2];
//     const savedType = step2?.interceptorType;
//     if (savedType) {
//       setInterceptorType(savedType);
//     }
//   }, [stepData[2]]);

//   // In CreateProjectForm - add this useEffect
//   // Resolves tab label even when StepTwo was never mounted
//   useEffect(() => {
//     if (capacityList.length === 0 || !stepData[2]) return;

//     // Get the saved capacityType from the API data
//     const step2Data = stepData[2]?.step2 || stepData[2];
//     const savedCapacityType = step2Data?.capacityType;

//     if (!savedCapacityType) return;

//     const found = capacityList.find(item => item.value === savedCapacityType);
//     if (!found) return;

//     const name = found.name?.toLowerCase() || "";
//     if (name.includes("liquid")) {
//       setCapacityTypeLabel("Liquid Capacity");
//     } else if (name.includes("sludge")) {
//       setCapacityTypeLabel("Sludge Capacity");
//     } else if (name.includes("grease")) {
//       setCapacityTypeLabel("Grease Capacity");
//     } else {
//       setCapacityTypeLabel(found.name || "Capacity");
//     }
//   }, [capacityList, stepData[2]]); // fires when either arrives

//   return (
//     <div className="crtePrjct">
//       <div className="container">
//         <div className="crtePrjct__tabs">
//           {tabList.map((item, idx) => {
//             const stepNumber = idx + 1;
//             const isStepCompleted = formValidations[`step${stepNumber}`] || stepNumber <= activeIndex;
//             const canNavigate = canNavigateToStep(idx);

//             return (
//               <span
//                 key={`tab__${idx}`}
//                 className={`
//                   ${currentTabIndex === idx ? "active" : ""}
//                   ${!canNavigate ? "disabled" : ""}
//                 `}
//                 onClick={async () => {
//                   if (!loading && canNavigate) {
//                     if (idx < 4 && projectId) {
//                       await loadStepData(idx + 1, true);
//                     }
//                     setCurrentTabIndex(idx); // 👈 always use index
//                   } else if (!canNavigate) {
//                     toast.error(`Please complete the previous steps ${stepNumber - 1}`);
//                   }
//                 }}
//                 style={{ cursor: canNavigate ? "pointer" : "not-allowed" }}
//               >
//                 {item.label}{" "}
//                 {isStepCompleted ? <FaCheckCircle color="#38c4ac" /> : null}
//                 <div
//                   className="bar"
//                   style={{
//                     ...(idx === 0 && { borderRadius: "5px 0 0 5px" }),
//                     ...(idx === tabList.length - 1 && { borderRadius: "0 5px 5px 0" }),
//                   }}
//                 />
//               </span>
//             );
//           })}
//           <div className="highLight" style={{ maxWidth: `${progressWidth}%` }} />
//         </div>

//         <div className="crtePrjct__content">
//           {currentTabIndex === TAB_INDICES.ABOUT && (
//             <StepOne
//               onNext={() => {
//                 updateFormValidation(1, true);
//                 setCurrentTabIndex(TAB_INDICES.LOCATION);
//               }}
//               loading={loading}
//               setLoading={setLoading}
//               setProjectId={setProjectId}
//               token={token}
//               existingData={stepData[1]}
//               projectId={projectId}
//             />
//           )}


//           {currentTabIndex === TAB_INDICES.LOCATION && (
//             <StepTwo
//               onPrev={() => setCurrentTabIndex(TAB_INDICES.ABOUT)}
//               onNext={() => {
//                 updateFormValidation(2, true);
//                 setCurrentTabIndex(TAB_INDICES.FIXTURES);
//               }}
//               loading={loading}
//               setLoading={setLoading}
//               projectId={projectId}
//               token={token}
//               existingData={stepData[2]}
//               loadStepData={loadStepData}
//               onCapacityTypeChange={(label) => setCapacityTypeLabel(label)}
//               onInterceptorTypeChange={(type) => setInterceptorType(type)}
//               capacityList={capacityList}
//               setCapacityList={setCapacityList}
//             />
//           )}

//           {currentTabIndex === TAB_INDICES.FIXTURES && (
//             <StepThree
//               onPrev={() => setCurrentTabIndex(TAB_INDICES.LOCATION)}
//               onNext={() => {
//                 updateFormValidation(3, true);
//                 if (isGravity) {
//                   updateFormValidation(4, true);
//                   setCurrentTabIndex(TAB_INDICES.SUMMARY);
//                 } else {
//                   setCurrentTabIndex(TAB_INDICES.GREASE_CAPACITY);
//                 }
//               }}
//               loading={loading}
//               setLoading={setLoading}
//               projectId={projectId}
//               token={token}
//               existingData={stepData[3]}
//               loadStepData={loadStepData}
//               capacityTypeLabel={capacityTypeLabel}
//             />
//           )}

//           {/* {currentTabIndex === TAB_INDICES.GREASE_CAPACITY && ( */}
//           {!isGravity && currentTabIndex === TAB_INDICES.GREASE_CAPACITY && (
//             <StepFour
//               onPrev={() => setCurrentTabIndex(TAB_INDICES.FIXTURES)}
//               onNext={() => {
//                 updateFormValidation(4, true);
//                 setCurrentTabIndex(TAB_INDICES.SUMMARY);
//               }}
//               loading={loading}
//               setLoading={setLoading}
//               projectId={projectId}
//               token={token}
//               existingData={stepData[4]}
//               loadStepData={loadStepData}
//               capacityTypeLabel={capacityTypeLabel}
//             />
//           )}

//           {currentTabIndex === TAB_INDICES.SUMMARY && (
//             <StepFive
//               onPrev={() => {
//                 if (isGravity) {
//                   setCurrentTabIndex(TAB_INDICES.FIXTURES);
//                 } else {
//                   setCurrentTabIndex(TAB_INDICES.GREASE_CAPACITY);
//                 }
//               }}
//               onNext={() => toast("Wow so easy! Ready to Create")}
//               loadStepData={loadStepData}
//               stepData={stepData}
//               projectId={projectId}
//               token={token}
//               capacityTypeLabel={capacityTypeLabel}
//               isGravity={isGravity}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };


// export default CreateProjectForm;


import React, { useEffect, useState } from "react";
import "stylesheets/createProject.scss";
import { FaAngleDown, FaCheckCircle, FaEnvelope, FaPhoneAlt, FaInfoCircle } from "react-icons/fa";
import Button from "components/button";
import InputBox from "components/comman/InputBox";
import SelectBox from "components/comman/SelectBox";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import RadioGroup from "components/comman/RadioGroup";
import { IoClose } from "react-icons/io5";
import { Images } from "constants/Images";
import DataTable from "react-data-table-component";
import CheckboxGroup from "components/comman/CheckboxGroup";
import { toast } from "react-toastify";
import { IoLocation } from "react-icons/io5";
import { IoMdCheckmark } from "react-icons/io";
import { BiGridAlt } from "react-icons/bi";
import { MdOutlineFastfood } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import AddFixtureModal from "components/modal/AddFixtureModal";
import ModalC from "components/comman/ModalC";
import { InlineEditor } from "components/InlineEditor";
import { API } from "API/API";
import { useAuthContext } from "context/auth/AuthContext";
import { ClipLoader } from "react-spinners";

const serveWare = [
  { label: "Paper plates and plastic utensils", value: "false", type: "noflatware" },
  { label: "With Flatware", value: "true", type: "withflatware" },
];

const GreaseProductionCosts = {
  low: { noflatware: 0.005, withflatware: 0.0065 },
  medium: { noflatware: 0.025, withflatware: 0.325 },
  high: { noflatware: 0.035, withflatware: 0.0455 },
  very_high: { noflatware: 0.058, withflatware: 0.75 },
};

const generateRandomKey = (length = 4) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let key = "";
  for (let i = 0; i < length; i++) key += chars.charAt(Math.floor(Math.random() * chars.length));
  return key;
};

const typeList = [
  { id: generateRandomKey(), value: "newConstruction", name: "New Construction" },
  { id: generateRandomKey(), value: "tenantFinish", name: "Remodel / Tenant Finish" },
  { id: generateRandomKey(), value: "shell", name: "Shell Space (Unknown Tenant)" },
  { id: generateRandomKey(), value: "interceptorReplacement", name: "Interceptor Replacement" },
];

const US_STATES = [
  { id: generateRandomKey(), value: "AL", name: "Alabama" },
  { id: generateRandomKey(), value: "AK", name: "Alaska" },
  { id: generateRandomKey(), value: "AZ", name: "Arizona" },
  { id: generateRandomKey(), value: "AR", name: "Arkansas" },
  { id: generateRandomKey(), value: "CA", name: "California" },
  { id: generateRandomKey(), value: "CO", name: "Colorado" },
  { id: generateRandomKey(), value: "CT", name: "Connecticut" },
  { id: generateRandomKey(), value: "DE", name: "Delaware" },
  { id: generateRandomKey(), value: "DC", name: "District of Columbia" },
  { id: generateRandomKey(), value: "FL", name: "Florida" },
  { id: generateRandomKey(), value: "GA", name: "Georgia" },
  { id: generateRandomKey(), value: "GU", name: "Guam" },
  { id: generateRandomKey(), value: "HI", name: "Hawaii" },
  { id: generateRandomKey(), value: "ID", name: "Idaho" },
  { id: generateRandomKey(), value: "IL", name: "Illinois" },
  { id: generateRandomKey(), value: "IN", name: "Indiana" },
  { id: generateRandomKey(), value: "IA", name: "Iowa" },
  { id: generateRandomKey(), value: "KS", name: "Kansas" },
  { id: generateRandomKey(), value: "KY", name: "Kentucky" },
  { id: generateRandomKey(), value: "LA", name: "Louisiana" },
  { id: generateRandomKey(), value: "ME", name: "Maine" },
  { id: generateRandomKey(), value: "MD", name: "Maryland" },
  { id: generateRandomKey(), value: "MA", name: "Massachusetts" },
  { id: generateRandomKey(), value: "MI", name: "Michigan" },
  { id: generateRandomKey(), value: "MN", name: "Minnesota" },
  { id: generateRandomKey(), value: "MS", name: "Mississippi" },
  { id: generateRandomKey(), value: "MO", name: "Missouri" },
  { id: generateRandomKey(), value: "MT", name: "Montana" },
  { id: generateRandomKey(), value: "NE", name: "Nebraska" },
  { id: generateRandomKey(), value: "NV", name: "Nevada" },
  { id: generateRandomKey(), value: "NH", name: "New Hampshire" },
  { id: generateRandomKey(), value: "NJ", name: "New Jersey" },
  { id: generateRandomKey(), value: "NM", name: "New Mexico" },
  { id: generateRandomKey(), value: "NY", name: "New York" },
  { id: generateRandomKey(), value: "NC", name: "North Carolina" },
  { id: generateRandomKey(), value: "ND", name: "North Dakota" },
  { id: generateRandomKey(), value: "OH", name: "Ohio" },
  { id: generateRandomKey(), value: "OK", name: "Oklahoma" },
  { id: generateRandomKey(), value: "OR", name: "Oregon" },
  { id: generateRandomKey(), value: "PA", name: "Pennsylvania" },
  { id: generateRandomKey(), value: "PR", name: "Puerto Rico" },
  { id: generateRandomKey(), value: "RI", name: "Rhode Island" },
  { id: generateRandomKey(), value: "SC", name: "South Carolina" },
  { id: generateRandomKey(), value: "SD", name: "South Dakota" },
  { id: generateRandomKey(), value: "TN", name: "Tennessee" },
  { id: generateRandomKey(), value: "TX", name: "Texas" },
  { id: generateRandomKey(), value: "UT", name: "Utah" },
  { id: generateRandomKey(), value: "VT", name: "Vermont" },
  { id: generateRandomKey(), value: "VA", name: "Virginia" },
  { id: generateRandomKey(), value: "WA", name: "Washington" },
  { id: generateRandomKey(), value: "WV", name: "West Virginia" },
  { id: generateRandomKey(), value: "WI", name: "Wisconsin" },
  { id: generateRandomKey(), value: "WY", name: "Wyoming" },
];

const CA_PROVINCES = [
  { id: generateRandomKey(), value: "BC", name: "British Columbia" },
  { id: generateRandomKey(), value: "ON", name: "Ontario" },
  { id: generateRandomKey(), value: "NL", name: "Newfoundland and Labrador" },
  { id: generateRandomKey(), value: "NS", name: "Nova Scotia" },
  { id: generateRandomKey(), value: "PE", name: "Prince Edward Island" },
  { id: generateRandomKey(), value: "NB", name: "New Brunswick" },
  { id: generateRandomKey(), value: "QC", name: "Quebec" },
  { id: generateRandomKey(), value: "MB", name: "Manitoba" },
  { id: generateRandomKey(), value: "SK", name: "Saskatchewan" },
  { id: generateRandomKey(), value: "AB", name: "Alberta" },
  { id: generateRandomKey(), value: "NT", name: "Northwest Territories" },
  { id: generateRandomKey(), value: "NU", name: "Nunavut" },
  { id: generateRandomKey(), value: "YT", name: "Yukon Territory" },
];

const STATE_OPTIONS = { US: US_STATES, CA: CA_PROVINCES };

const stateList = [
  { id: generateRandomKey(), value: "", name: "Select" },
  { id: generateRandomKey(), value: "AL", name: "Alabama" },
  { id: generateRandomKey(), value: "AK", name: "Alaska" },
  { id: generateRandomKey(), value: "AZ", name: "Arizona" },
  { id: generateRandomKey(), value: "AR", name: "Arkansas" },
];

const countryList = [
  { id: generateRandomKey(), value: "US", name: "United States" },
  { id: generateRandomKey(), value: "CA", name: "Canada" },
];

const insideLocationList = [
  { id: generateRandomKey(), value: "kitchen", name: "Kitchen" },
  { id: generateRandomKey(), value: "inBasement", name: "In Basement" },
  { id: generateRandomKey(), value: "parkingGarage", name: "Parking Garage" },
  { id: generateRandomKey(), value: "suspendedPenetratingFloor", name: "Suspended / Penetrating Floor" },
  { id: generateRandomKey(), value: "otherLocation", name: "Other Location" },
];

const mealList = [
  {
    id: generateRandomKey(),
    title: "Meals per day",
    label: "Meals per day",
    value: 0,
    data: "",
    perDay: "",
    calculation: (value) => value,
  },
];

const stepOneSchema = yup.object({
  typeSelect: yup.string().required().label("Construction Type"),
  projectName: yup.string().required().label("Facility/Project Name"),
  streetAddress: yup.string().optional(),
  city: yup.string().required().label("City"),
  state: yup.string().required().label("State/Region"),
  zipCode: yup.string().optional(),
  country: yup.string().required().label("Country"),
  note: yup.string().optional(),
});

const stepTwoSchema = yup.object({
  capacityType: yup.string().required().label("Capacity Type"),
  interceptorType: yup.string().required().label("Interceptor Type"),
  trapLocation: yup.string().required().label("Trap Location"),
  insideLocation: yup.string().when("trapLocation", {
    is: "indoors",
    then: yup.string().required().label("Where Inside"),
    otherwise: yup.string().optional(),
  }),
  buried: yup.string().required().label("Buried"),
  pumpOutIncluded: yup.string().when("trapLocation", {
    is: "indoors",
    then: yup.string().required().label("Pump Out Included"),
    otherwise: yup.string().optional(),
  }),
  installedInTraffic: yup.string().when(["trapLocation", "buried"], {
    is: (trapLocation, buried) => trapLocation === "indoors" && buried === "yes",
    then: yup.string().required().label("Installed in Traffic"),
    otherwise: yup.string().optional(),
  }),
  accuracy: yup.string().required().label("Efficiency Compliance"),
  solidInterceptorRequired: yup.string().required().label("Solid Interceptor Required"),
});

const stepThreeSchema = yup.object({
  pipeSize: yup.string().optional().label("Pipe Size"),
});

const stepFourSchema = yup.object({
  appliances: yup.array().of(yup.string()).optional(),
  flatware: yup.string().required().label("Flat ware"),
  bestDescribe: yup.string().required("Best describe is required"),
  mealType: yup.object().shape({
    type: yup.string().required("Meal type is required"),
    value: yup.number().typeError("Value must be a number").required("Value is required"),
  }),
  sqfBuilding: yup.number().nullable().transform((value, originalValue) => String(originalValue).trim() === "" ? null : value).positive("Must be a positive number").optional(),
  diningAreaPercentage: yup.number().nullable().transform((value, originalValue) => String(originalValue).trim() === "" ? null : value).positive("Must be a positive number").max(100, "Cannot exceed 100").optional(),
  sqfPerPerson: yup.number().nullable().transform((value, originalValue) => String(originalValue).trim() === "" ? null : value).positive("Must be a positive number").optional(),
  turnsPerSeat: yup.number().nullable().transform((value, originalValue) => String(originalValue).trim() === "" ? null : value).positive("Must be a positive number").optional(),
  pumpOutCycle: yup.string().required("Pump Out Cycle is required"),
});

const transformStepOneData = (formData) => ({
  step: 1,
  constructionType: formData.typeSelect,
  projectName: formData.projectName,
  address: {
    street: formData.streetAddress || "",
    country: formData.country,
    state: formData.state,
    city: formData.city,
    zip: formData.zipCode || "",
  },
  authorityHavingJurisdiction: formData.note || "",
  engineerName: formData.representative || "",
  representative: formData.representative || "",
});

const transformStepTwoData = (formData) => ({
  step: 2,
  interceptorType: formData.interceptorType,
  greeceInterceptorLocation: formData.trapLocation,
  willBurried: formData.buried === "yes",
  insideArea: formData.insideLocation || "",
  isInstallPort: formData.pumpOutIncluded === "yes",
  willInstallVehichleTrafficArea: formData.installedInTraffic === "yes",
  accuracy: formData.accuracy === "yes",
  materialType: formData.capacityType,
  solidInterceptorRequired: formData.solidInterceptorRequired === "yes",
});

const transformStepThreeData = (formData, fixtures) => ({
  step: 3,
  drainagePipeSize: formData.pipeSize ? parseFloat(formData.pipeSize) : "",
  fixtures: fixtures.map((fixture) => ({
    fixtureType: fixture.fixtureType,
    fixtureName: fixture.fixtureName,
    trapSize: fixture.trapSize,
    dfuType: fixture.dfuType,
    dfuValue: parseFloat(fixture.dfuValue) || 0,
    gpm: fixture.gpm || "",
    quantity: parseInt(fixture.quantity) || 1,
    flowRate: fixture.flowRate || "",
    included: fixture.included !== false,
    image: fixture.image || null,
    ...(fixture.fixtureType === "custom_sink"
      ? { dimensions: { length: fixture.length, width: fixture.width, depth: fixture.depth, compartments: fixture.compartments } }
      : {}),
  })),
});

const transformStepFourData = (formData, selectMenu, calculatedMeals, calculatedGreaseCost, selectedServeWare, extraData) => ({
  step: 4,
  kitchenAppliances: formData.appliances,
  servingWare: selectedServeWare.label,
  menu: selectMenu?.title || "",
  menuValue: calculatedMeals || 0,
  lbs: calculatedGreaseCost || 0,
  sqfBuilding: extraData?.sqfBuilding || "",
  diningAreaPercentage: extraData?.diningAreaPercentage || "",
  sqfPerPerson: extraData?.sqfPerPerson || "",
  turnsPerSeat: extraData?.turnsPerSeat || "",
  pumpOutCycle: extraData?.pumpOutCycle || "",
});

const reverseTransformStepOneData = (apiData) => {
  if (!apiData) return {};
  const step1Data = apiData.step1 || apiData;
  return {
    typeSelect: step1Data.constructionType || "",
    projectName: step1Data.projectName || "",
    streetAddress: step1Data.address?.street || "",
    city: step1Data.address?.city || "",
    state: step1Data.address?.state || "",
    zipCode: step1Data.address?.zip || "",
    country: step1Data.address?.country || "US",
    note: step1Data.authorityHavingJurisdiction || "",
    representative: step1Data.engineerName || "",
  };
};

const reverseTransformStepTwoData = (apiData) => {
  if (!apiData) return {};
  const step2Data = apiData.step2 || apiData;
  return {
    interceptorType: step2Data.interceptorType || "",
    trapLocation: step2Data.greeceInterceptorLocation || "indoors",
    buried: step2Data.willBurried ? "yes" : "no",
    capacityType: step2Data.materialType || "",
    insideLocation: step2Data.insideArea || "",
    pumpOutIncluded: step2Data.isInstallPort ? "yes" : "no",
    installedInTraffic: step2Data.willInstallVehichleTrafficArea ? "yes" : "no",
    accuracy: step2Data.accuracy ? "yes" : "no",
    solidInterceptorRequired: step2Data.solidInterceptorRequired ? "yes" : "no",
  };
};

const reverseTransformStepThreeData = (apiData) => {
  if (!apiData) return { pipeSize: "2", fixtures: [] };
  const step3Data = apiData.step3 || apiData;
  const fixtures = (step3Data.fixtures || []).map((fixture) => ({
    id: generateRandomKey(),
    included: fixture.included !== false,
    fixtureType: fixture.fixtureType || "",
    fixtureName: fixture.fixtureName || "",
    trapSize: fixture.trapSize || "",
    dfuType: fixture.dfuType || "",
    dfuValue: fixture.dfuValue || "",
    gpm: fixture.gpm || "",
    length: fixture.dimensions?.length || "",
    width: fixture.dimensions?.width || "",
    depth: fixture.dimensions?.depth || fixture.dimensions?.height || "",
    compartments: fixture.dimensions?.compartments || "",
    quantity: String(fixture.quantity || 1),
    flowRate: fixture.flowRate || "",
    image: fixture.image || null,
  }));
  return { pipeSize: step3Data.drainagePipeSize || "4", fixtures };
};

const reverseTransformStepFourData = (apiData, menuList = []) => {
  if (!apiData) return {};
  const step4Data = apiData.step4 || apiData;
  let matchedMenu = step4Data.selectedMenu;
  let matchedServeWare = step4Data.selectedServeWare;
  if (!matchedMenu && step4Data.menu) matchedMenu = menuList.find((menu) => menu.title === step4Data.menu);
  if (!matchedServeWare && step4Data.servingWare) matchedServeWare = serveWare.find((ware) => ware.label === step4Data.servingWare);
  let selectedMealData = step4Data.selectedMealData;
  if (!selectedMealData && step4Data.mealType && step4Data.mealType.type) selectedMealData = mealList.find((meal) => meal.title === step4Data.mealType.type);
  if (!selectedMealData) selectedMealData = mealList.find((meal) => meal.title === "Meals per day");
  return {
    appliances: step4Data.appliances || step4Data.kitchenAppliances || [],
    flatware: matchedServeWare?.value || step4Data.flatware || "true",
    bestDescribe: matchedMenu?.title || step4Data.bestDescribe || step4Data.menu || "",
    selectedMenu: matchedMenu,
    selectedServeWare: matchedServeWare,
    calculatedMeals: step4Data.calculatedMeals || step4Data.menuValue || 0,
    calculatedGreaseCost: step4Data.calculatedGreaseCost || step4Data.lps || 0,
    selectedMealData: selectedMealData,
    mealType: { type: selectedMealData?.title || "Meals per day", value: step4Data.calculatedMeals || step4Data.menuValue || 0 },
    sqfBuilding: step4Data.sqfBuilding || "",
    diningAreaPercentage: step4Data.diningAreaPercentage || "",
    sqfPerPerson: step4Data.sqfPerPerson || "",
    turnsPerSeat: step4Data.turnsPerSeat || "",
    pumpOutCycle: step4Data.pumpOutCycle || "",
  };
};

// ─── STEP ONE ───────────────────────────────────────────────────────────────
const StepOne = ({ onNext, loading, setLoading, setProjectId, token, existingData, projectId }) => {
  const { handleSubmit, control, setValue, watch, reset } = useForm({
    resolver: yupResolver(stepOneSchema),
    defaultValues: { country: "US", state: "" },
  });

  const selectedCountry = watch("country");
  const stateSelectList =
    selectedCountry && STATE_OPTIONS[selectedCountry]
      ? STATE_OPTIONS[selectedCountry]
      : [{ id: generateRandomKey(), value: "", name: "Select" }];

  const handleBtn = async (formData) => {
    setLoading(true);
    try {
      const apiData = transformStepOneData(formData);
      let response;
      if (projectId) {
        response = await API.updateCalculatorConfiguration(projectId, apiData, token);
      } else {
        response = await API.createCalculatorConfiguration(apiData, token);
      }
      if (response && response.success) {
        if (!projectId && response.data?.configurationId) setProjectId(response.data.configurationId);
        toast.success(response.message || "Project information saved successfully!");
        onNext();
      } else {
        toast.error(response?.message || "Failed to save project information. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while saving project information. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (existingData) {
      const formData = reverseTransformStepOneData(existingData);
      reset(formData);
    }
  }, [existingData, reset]);

  return (
    <div className="stepWrap">
      <div className="stepWrap__header">
        <div className="stepWrap__headerLeft">
          <h2>Project Details</h2>
          <p>Enter basic project information for reference and reporting.</p>
        </div>
        <span className="asmeTag">ASME Sizing Guidelines</span>
      </div>

      <div className="stepWrap__section">
        <div className="stepWrap__sectionLabel">PROJECT INFORMATION</div>
        <div className="stepWrap__type">
          <div className="row">
            <div className="col-6">
              <InputBox label="Project Name *" name="projectName" control={control} />
            </div>
            <div className="col-6">
              <SelectBox control={control} name="typeSelect" label="Building Description: *" selectList={typeList} />
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <SelectBox label="Country *" name="country" selectList={countryList} control={control} />
            </div>
            <div className="col-3">
              <SelectBox label="State / Province *" name="state" selectList={stateSelectList} control={control} />
            </div>
            <div className="col-3">
              <InputBox label="City *" name="city" control={control} />
            </div>
            <div className="col-3">
              <InputBox label="Zip / Area Code" name="zipCode" control={control} />
            </div>
          </div>
        </div>
      </div>

      <div className="stepWrap__section">
        <div className="stepWrap__sectionLabel">AUTHORITY</div>
        <div className="stepWrap__type">
          <div className="row">
            <div className="col-6">
              <InputBox label="Engineer Name" name="representative" control={control} />
            </div>
            <div className="col-6">
              <InputBox label="AHJ (Authority Having Jurisdiction)" name="note" control={control} />
            </div>
          </div>
        </div>
      </div>

      <div className="stepWrap__cta">
        <Button white label="Back" disabled />
        <Button label={loading ? "Saving..." : "Next Step →"} onClick={handleSubmit(handleBtn)} disabled={loading} />
      </div>
    </div>
  );
};

// ─── PUMP OUT PORT ──────────────────────────────────────────────────────────
const PumpOutPort = ({ show, onClose }) => (
  <div className={`pump ${show ? "show" : null}`}>
    <div className="pump__header">
      <h4>Pumpout Port</h4>
      <button type="button" onClick={onClose}><IoClose /></button>
    </div>
    <div className="pump__body">
      <div className="img">
        <img src="/images/pump-img.png" alt="" />
        <p>A pumpout port provides remote access for pumping and eliminates the need for unsanitary pumper equipment inside the building.</p>
      </div>
      <div className="row">
        <div className="col-6">
          <div className="imgWrap">
            <img src="/images/pump-pp1.png" alt="" />
            <h5>PP1</h5>
            <a href="https://schierproducts.com/shop/pp1" target="_blank">View</a>
          </div>
        </div>
        <div className="col-6">
          <div className="imgWrap">
            <img src="/images/pump-pp2.png" alt="" />
            <h5>PP3</h5>
            <a href="https://schierproducts.com/shop/pp3" target="_blank">View</a>
          </div>
        </div>
      </div>
      <div className="cta"><Button label="Got IT" onClick={onClose} /></div>
    </div>
  </div>
);

// ─── STEP TWO ────────────────────────────────────────────────────────────────
const StepTwo = ({ onPrev, onNext, loading, setLoading, projectId, token, existingData, loadStepData, onCapacityTypeChange, onInterceptorTypeChange, capacityList, setCapacityList }) => {
  const [pumpOut, setPumpOut] = useState();
  const { handleSubmit, control, setValue, watch, reset } = useForm({
    resolver: yupResolver(stepTwoSchema),
    defaultValues: { capacityType: "", interceptorType: "", trapLocation: "inside", buried: "no", accuracy: "no", solidInterceptorRequired: "no" },
  });

  const handleBtn = async (formData) => {
    if (!projectId) { toast.error("Project ID not found. Please restart the process from Step 1."); return; }
    setLoading(true);
    try {
      const apiData = transformStepTwoData(formData);
      const response = await API.updateCalculatorConfiguration(projectId, apiData, token);
      if (response && response.success) {
        toast.success(response.message || "Location information saved successfully!");
        onNext();
      } else {
        toast.error(response?.message || "Failed to save location information. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while saving location information. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const selectedTrapLocation = watch("trapLocation");
  const selectedBuried = watch("buried");

  const handlePrevious = async () => { await loadStepData(1, true); onPrev(); };

  useEffect(() => {
    if (existingData) { const formData = reverseTransformStepTwoData(existingData); reset(formData); }
  }, [existingData, reset]);

  const selectedInterceptorType = watch("interceptorType");
  useEffect(() => { if (selectedInterceptorType && onInterceptorTypeChange) onInterceptorTypeChange(selectedInterceptorType); }, [selectedInterceptorType]);

  const selectedCapacityType = watch("capacityType");
  useEffect(() => {
    if (selectedCapacityType && capacityList?.length > 0) {
      const found = capacityList.find((item) => item?.value === selectedCapacityType);
      if (found && onCapacityTypeChange) {
        const name = found.name?.toLowerCase() || "";
        if (name.includes("liquid")) onCapacityTypeChange("Liquid Capacity");
        else if (name.includes("sludge")) onCapacityTypeChange("Sludge Capacity");
        else onCapacityTypeChange(found.name || "Grease Capacity");
      }
    }
  }, [selectedCapacityType, capacityList]);

  return (
    <div className="stepWrap">
      <div className="stepWrap__header">
        <div className="stepWrap__headerLeft">
          <h2>Interceptor Installation</h2>
        </div>
        <span className="asmeTag">ASME Sizing Guidelines</span>
      </div>

      <div className="row">
        <div className="col-6">
          <SelectBox label="Material Type *" name="capacityType" selectList={capacityList} control={control} />
          <RadioGroup name="accuracy" control={control} defaultValue="no" label="Does the Interceptor need 99% grease efficiency? *"
            options={[{ label: "Yes", value: "yes" }, { label: "No", value: "no" }]}
            rules={{ required: "Please select efficiency compliance." }} />
          <RadioGroup name="buried" control={control} defaultValue="no" label="Is the Interceptor buried in the ground? *"
            options={[{ label: "Yes", value: "yes" }, { label: "No", value: "no" }]}
            rules={{ required: "Please select buried option." }} />
          <RadioGroup name="solidInterceptorRequired" control={control} defaultValue="no" label="Do you require Solid Interceptor? *"
            options={[{ label: "Yes", value: "yes" }, { label: "No", value: "no" }]}
            rules={{ required: "Please select solid interceptor option." }} />
        </div>
        <div className="col-6">
          <RadioGroup name="interceptorType" control={control} defaultValue="" label="Interceptor Type *"
            options={[{ label: "Hydromechanical", value: "hydromechanical" }, { label: "Gravity", value: "gravity" }]}
            rules={{ required: "Please select an interceptor type." }} />
          <RadioGroup name="trapLocation" control={control} defaultValue="inside" label="Location of Interceptor?"
            options={[{ label: "Inside", value: "inside" }, { label: "Outside", value: "outside" }]}
            rules={{ required: "Please select a trap location." }} />
          {selectedTrapLocation === "inside" && (
            <SelectBox label="Where inside? *" name="insideLocation" selectList={insideLocationList} control={control} />
          )}
          {selectedTrapLocation === "inside" && (
            <RadioGroup name="pumpOutIncluded" control={control} defaultValue="yes"
              label="Install a port to allow for remote pumpout of the tank? *"
              options={[{ label: "Yes", value: "yes" }, { label: "No", value: "no" }]}
              rules={{ required: "Please select pump out option." }} />
          )}
          {selectedTrapLocation === "inside" && selectedBuried === "yes" && (
            <RadioGroup name="installedInTraffic" control={control} defaultValue="yes"
              label="Will it be installed in a vehicle traffic area? *"
              options={[{ label: "Yes", value: "yes" }, { label: "No", value: "no" }]}
              rules={{ required: "Please select traffic area option." }} />
          )}
        </div>
      </div>

      <div className="stepWrap__cta">
        <Button white label="Previous" onClick={handlePrevious} />
        <Button label={loading ? "Saving..." : "Continue"} onClick={handleSubmit(handleBtn)} />
      </div>
    </div>
  );
};

// ─── STEP THREE ──────────────────────────────────────────────────────────────
const StepThree = ({ onPrev, onNext, loading, setLoading, projectId, token, existingData, loadStepData, capacityTypeLabel }) => {
  const [fixtures, setFixtures] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editForm, setEditForm] = useState({ included: true, fixtureType: "", fixtureName: "", trapSize: "", dfuType: "", dfuValue: "", gpm: "", length: "", width: "", depth: "", compartments: "", quantity: 1, flowRate: "" });
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [fixtureTypesList, setFixtureTypesList] = useState([]);
  const [isLoadingFixtures, setIsLoadingFixtures] = useState(true);

  const { handleSubmit, control, reset } = useForm({ resolver: yupResolver(stepThreeSchema), defaultValues: { pipeSize: "4" } });

  useEffect(() => {
    const fetchFixtureTypes = async () => {
      setIsLoadingFixtures(true);
      try {
        const response = await API.fetchListingDataFixture();
        if (response && response?.success && response?.data) {
          const transformedFixtures = response?.data?.map((fixture) => ({
            id: generateRandomKey(), value: fixture?.name, name: fixture?.name,
            trapSize: fixture?.trapSize || "", privateDfu: fixture?.privateDfu ? parseFloat(fixture.privateDfu) : null,
            publicDfu: fixture?.publicDfu ? parseFloat(fixture.publicDfu) : null,
            image: fixture?.image || null,
          }));
          transformedFixtures.push({ id: generateRandomKey(), value: "other", name: "Manual Fixture Sizing", trapSize: "", privateDfu: null, publicDfu: null, image: null });
          transformedFixtures.push({ id: generateRandomKey(), value: "custom_sink", name: "Custom Sink Sizing", trapSize: "", privateDfu: null, publicDfu: null, image: null });
          console.log("transformedFixtures", transformedFixtures);
          setFixtureTypesList(transformedFixtures);
        } else { toast.error("Failed to load fixture types"); setFixtureTypesList([]); }
      } catch (error) { toast.error("Error loading fixture types from server"); setFixtureTypesList([]); }
      finally { setIsLoadingFixtures(false); }
    };
    fetchFixtureTypes();
  }, []);

  const getDfuOptions = (fixtureType) => {
    const fixture = fixtureTypesList.find((f) => f.value === fixtureType);
    if (!fixture) return [];
    const options = [];
    if (fixture.privateDfu !== null && fixture.privateDfu !== undefined) options.push({ id: generateRandomKey(), value: "private", name: "Private" });
    if (fixture.publicDfu !== null && fixture.publicDfu !== undefined) options.push({ id: generateRandomKey(), value: "public", name: "Public" });
    return options;
  };

  const beginEdit = (row) => {
    setEditingRowId(row.id);
    setEditForm({ included: row.included ?? true, fixtureType: row.fixtureType || "", fixtureName: row.fixtureName || "", trapSize: row.trapSize || "", dfuType: row.dfuType || "", dfuValue: row.dfuValue || "", gpm: row.gpm || "", image: row.image || null, length: row.length || "", width: row.width || "", depth: row.depth || "", compartments: row.compartments || "", quantity: parseInt(row.quantity || 1, 10), flowRate: row.flowRate || "" });
  };

  const cancelEdit = () => { setEditingRowId(null); setIsAddingNew(false); setEditForm({ included: true, fixtureType: "", fixtureName: "", trapSize: "", dfuType: "", dfuValue: "", gpm: "", image: null, length: "", width: "", depth: "", compartments: "", quantity: 1, flowRate: "" }); };

  const saveEdit = (data) => {
    if (isAddingNew) {
      const id = generateRandomKey();
      setFixtures((prev) => [...prev, { id, included: data.included, fixtureType: data.fixtureType, fixtureName: data.fixtureName, trapSize: data.trapSize, dfuType: data.dfuType, dfuValue: data.dfuValue, gpm: data.gpm, image: data.image, length: data.length, width: data.width, depth: data.depth, compartments: data.compartments, quantity: String(data.quantity), flowRate: data.flowRate }]);
      setIsAddingNew(false);
    } else {
      setFixtures((prev) => prev.map((item) => item.id !== editingRowId ? item : { ...item, ...data, quantity: String(data.quantity) }));
    }
    setEditingRowId(null);
  };

  const addNewRowAndEdit = () => { setIsAddingNew(true); setEditingRowId(null); setEditForm({ included: true, fixtureType: "", fixtureName: "", trapSize: "", dfuType: "", dfuValue: "", gpm: "", image: null, length: "", width: "", depth: "", compartments: "", quantity: 1, flowRate: "" }); };
  const handleDeleteClick = (e, row) => { e.preventDefault(); const index = fixtures.findIndex((f) => f.id === row.id); setDeleteIndex(index); setShowDeleteModal(true); };
  const handleEdit = (e, row) => { e.preventDefault(); setIsAddingNew(false); beginEdit(row); };
  const handleQuantityChange = (increment) => { setEditForm((prev) => ({ ...prev, quantity: Math.max(1, prev.quantity + increment) })); };
  const onChangeEditForm = (patch) => { setEditForm((prev) => ({ ...prev, ...patch })); };

  const onChangeFixtureType = (value) => {
    if (value === "other" || value === "custom_sink") {
      setEditForm((prev) => ({ ...prev, fixtureType: value, fixtureName: value === "custom_sink" ? "Custom Sink Sizing" : "", trapSize: "", gpm: "", dfuType: "", dfuValue: "", image: null, length: "", width: "", depth: "", compartments: "", flowRate: "" }));
      return;
    }
    const selected = fixtureTypesList.find((f) => f.value === value);
    setEditForm((prev) => ({ ...prev, fixtureType: value, fixtureName: selected ? selected.name : "", trapSize: selected ? selected.trapSize : "", gpm: selected ? selected.gpm : "", image: selected ? selected.image : null, dfuType: "", dfuValue: "", length: "", width: "", depth: "", compartments: "", flowRate: "" }));
  };

  const onChangeDfuType = (value) => {
    const fixture = fixtureTypesList.find((f) => f.value === editForm.fixtureType);
    let dfuValue = "";
    if (fixture && value === "private") dfuValue = fixture.privateDfu;
    else if (fixture && value === "public") dfuValue = fixture.publicDfu;
    setEditForm((prev) => ({ ...prev, dfuType: value, dfuValue }));
  };

  const columns = [
    {
      name: "Fixture Name",
      selector: (row) => row.fixtureName,
      cell: (row) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div className="fixture-circle-icon">
            {row.image ? (
              <img src={`${process.env.REACT_APP_IMAGE_BASEURL?.replace(/\/product-image\/?$/, "")}/${row.image}`} alt="" />
            ) : (
              <div className="fixture-circle-placeholder">
                {(() => {
                  if (!row.fixtureName) return "";
                  const parts = row.fixtureName.trim().split(/\s+/);
                  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
                  return row.fixtureName.substring(0, 2).toUpperCase();
                })()}
              </div>
            )}
          </div>
          <span>{row.fixtureName}</span>
        </div>
      )
    },
    { name: "Trap Size", selector: (row) => row.trapSize, cell: (row) => row?.trapSize ? `${row.trapSize}"` : "N/A" },
    { name: "DFU Type", selector: (row) => row.dfuType, cell: (row) => row?.dfuType || "N/A" },
    { name: "DFU Value", selector: (row) => row.dfuValue, cell: (row) => row?.dfuValue || "N/A" },
    { name: "GPM", selector: (row) => row.gpm, cell: (row) => row?.gpm || "N/A" },
    { name: "Quantity", selector: (row) => row.quantity, cell: (row) => row?.quantity },
    { name: "Flow Rate", selector: (row) => row.flowRate, cell: (row) => row?.flowRate ? `${row.flowRate} GPM` : "N/A" },
    {
      name: "Actions", selector: (row) => row.quantity,
      cell: (row) => (
        <ul className="tableCta">
          <li><img src={Images.icon.edit} alt="edit" onClick={(e) => handleEdit(e, row)} style={{ cursor: "pointer" }} /></li>
          <li><img src={Images.icon.delete} alt="delete" onClick={(e) => handleDeleteClick(e, row)} style={{ cursor: "pointer" }} /></li>
        </ul>
      ),
    },
  ];

  const customSinkColumns = [
    { name: "Fixture Name", selector: (row) => row.fixtureType, cell: () => "Custom Sink Sizing" },
    { name: "Length (L)", selector: (row) => row.length, cell: (row) => row?.length },
    { name: "Width (W)", selector: (row) => row.width, cell: (row) => row?.width },
    { name: "Depth (D)", selector: (row) => row.depth, cell: (row) => row?.depth },
    { name: "Compartments (N)", selector: (row) => row.compartments, cell: (row) => row?.compartments },
    { name: "Flow Rate", selector: (row) => row.flowRate, cell: (row) => row?.flowRate ? `${row.flowRate} GPM` : "N/A" },
    {
      name: "Actions",
      cell: (row) => (
        <ul className="tableCta">
          <li><img src={Images.icon.edit} alt="edit" onClick={(e) => handleEdit(e, row)} style={{ cursor: "pointer" }} /></li>
          <li><img src={Images.icon.delete} alt="delete" onClick={(e) => handleDeleteClick(e, row)} style={{ cursor: "pointer" }} /></li>
        </ul>
      ),
    },
  ];

  const handleBtn = async (formData) => {
    if (!projectId) { toast.error("Project ID not found. Please restart the process from Step 1."); return; }
    if (fixtures.length === 0) { toast.error("Please add at least one fixture before continuing."); return; }
    setLoading(true);
    try {
      const apiData = transformStepThreeData(formData, fixtures);
      const response = await API.updateCalculatorConfiguration(projectId, apiData, token);
      if (response && response.success) { toast.success(response.message || "Fixture information saved successfully!"); onNext(); }
      else toast.error(response?.message || "Failed to save fixture information. Please try again.");
    } catch (error) { toast.error("An error occurred while saving fixture information. Please try again."); }
    finally { setLoading(false); }
  };

  const handlePrevious = async () => { await loadStepData(2, true); onPrev(); };

  useEffect(() => {
    if (existingData) {
      const { pipeSize, fixtures: existingFixtures } = reverseTransformStepThreeData(existingData);
      reset({ pipeSize });
      setFixtures(existingFixtures);
    }
  }, [existingData, reset]);

  const expandableProps = { editForm, fixtureTypesList, onChangeEditForm, onChangeFixtureType, onChangeDfuType, onQuantityChange: handleQuantityChange, onCancel: cancelEdit, onSave: saveEdit, getDfuOptions };

  return (
    <div className="stepWrap">
      <div className="stepWrap__header">
        <div className="stepWrap__headerLeft">
          <h2>Connection Information</h2>
        </div>
        <span className="asmeTag">ASME Sizing Guidelines</span>
      </div>

      <RadioGroup name="pipeSize" rows control={control} defaultValue="4"
        label="Pipe size connected to the interceptor ?"
        options={[{ label: `2"`, value: "2" }, { label: `3"`, value: "3" }, { label: `4"`, value: "4" }, { label: `6"`, value: "6" }, { label: `Don't Know`, value: "" }]}
        rules={{ required: "Please select a trap location." }} />

      <div className="stepWrap__fixturesBanner" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
        background: '#e3f2fd',
        padding: '16px 24px',
        borderRadius: '10px',
        border: '1px solid #bbdefb'
      }}>
        <div style={{ flex: 1, paddingRight: '20px' }}>
          <p style={{ margin: 0, fontSize: '15px', color: '#0d47a1', fontWeight: '600', lineHeight: '1.4' }}>
            Add the fixtures connected to the grease interceptor. We'll calculate total flow automatically.
          </p>
        </div>
        {!isAddingNew && (
          <button type="button" onClick={addNewRowAndEdit} style={{
            cursor: "pointer",
            fontSize: "14px",
            color: "white",
            fontWeight: "700",
            border: "none",
            padding: "10px 20px",
            borderRadius: "6px",
            background: "#0d47a1",
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            whiteSpace: 'nowrap'
          }}>
            <span style={{ fontSize: '18px' }}>+</span> Add Another Fixture
          </button>
        )}
      </div>

      {isAddingNew && (
        <div style={{ marginBottom: "30px" }}>
          <InlineEditor editForm={editForm} fixtureTypesList={fixtureTypesList} onChangeEditForm={onChangeEditForm}
            onChangeFixtureType={onChangeFixtureType} onChangeDfuType={onChangeDfuType}
            onQuantityChange={handleQuantityChange} onCancel={cancelEdit} onSave={saveEdit} getDfuOptions={getDfuOptions} />
        </div>
      )}

      {(fixtures.length === 0 || fixtures.filter((f) => f.fixtureType !== "custom_sink").length > 0) && (
        <div style={{ marginBottom: "30px" }}>
          {fixtures.filter((f) => f.fixtureType === "custom_sink").length > 0 && (
            <h3 style={{ fontSize: "16px", marginBottom: "15px", fontWeight: "600", color: "#333" }}>Standard Fixtures</h3>
          )}
          <DataTable keyField="id" columns={columns} data={fixtures.filter((f) => f.fixtureType !== "custom_sink")}
            pagination expandableRows expandableRowsHideExpander
            expandableRowExpanded={(row) => row.id === editingRowId}
            expandableRowsComponent={InlineEditor} expandableRowsComponentProps={expandableProps}
            onRowExpandToggled={(expanded, row) => { if (!expanded && row.id === editingRowId) setEditingRowId(null); }} />
        </div>
      )}

      {fixtures.filter((f) => f.fixtureType === "custom_sink").length > 0 && (
        <div style={{ marginBottom: "30px" }}>
          <h3 style={{ fontSize: "16px", marginBottom: "15px", fontWeight: "600", color: "#333" }}>Custom Sink Sizing</h3>
          <DataTable keyField="id" columns={customSinkColumns} data={fixtures.filter((f) => f.fixtureType === "custom_sink")}
            pagination expandableRows expandableRowsHideExpander
            expandableRowExpanded={(row) => row.id === editingRowId}
            expandableRowsComponent={InlineEditor} expandableRowsComponentProps={expandableProps}
            onRowExpandToggled={(expanded, row) => { if (!expanded && row.id === editingRowId) setEditingRowId(null); }} />
        </div>
      )}



      <div className="stepWrap__cta">
        <Button white label="Previous" onClick={handlePrevious} />
        <Button label={loading ? "Saving..." : "Continue"} onClick={handleSubmit(handleBtn)} disabled={loading} />
      </div>

      {showDeleteModal && (
        <ModalC title="Delete Fixture" message="Are you sure you want to delete this fixture?" showmodal={true}
          handleClose={() => setShowDeleteModal(false)}
          handleYes={() => {
            setFixtures((prev) => prev.filter((_, i) => i !== deleteIndex));
            setShowDeleteModal(false);
            setDeleteIndex(null);
            if (editingRowId && fixtures[deleteIndex]?.id === editingRowId) setEditingRowId(null);
          }} />
      )}
    </div>
  );
};

// ─── STEP FOUR ───────────────────────────────────────────────────────────────
const StepFour = ({ onPrev, onNext, loading, setLoading, projectId, token, existingData, loadStepData, capacityTypeLabel }) => {
  const [selectMenu, setSelectMenu] = useState();
  const [showMenu, setShowMenu] = useState();
  const [mealData, setMealData] = useState();
  const [inputValue, setInputValue] = useState("");
  const [calculatedGreaseCost, setCalculatedGreaseCost] = useState(0);
  const [calculationBreakdown, setCalculationBreakdown] = useState("");
  const initialServeWare = serveWare.find((item) => item.value === "true");
  const [selectedServeWare, setSelectedServeWare] = useState(initialServeWare);
  const [calculatedMeals, setCalculatedMeals] = useState(0);
  const [menuList, setMenuList] = useState([]);
  const [isLoadingMenu, setIsLoadingMenu] = useState(true);

  const { register, handleSubmit, control, setValue, watch, formState, reset } = useForm({
    resolver: yupResolver(stepFourSchema),
    defaultValues: { appliances: [], sqfBuilding: "", diningAreaPercentage: "", sqfPerPerson: "", turnsPerSeat: "", pumpOutCycle: "", mealType: { type: "Meals per day", value: 0 } },
  });

  const sqfBuilding = watch("sqfBuilding");
  const diningAreaPercentage = watch("diningAreaPercentage");
  const sqfPerPerson = watch("sqfPerPerson");
  const turnsPerSeat = watch("turnsPerSeat");
  const pumpOutCycle = watch("pumpOutCycle");
  const selectedAppliances = watch("appliances") || [];

  useEffect(() => {
    if (selectMenu && selectedServeWare && calculatedMeals && pumpOutCycle) {
      const prodRate = GreaseProductionCosts[selectMenu?.type]?.[selectedServeWare?.type?.toLowerCase()];
      let calcValue = prodRate * calculatedMeals;
      if (!isNaN(calcValue)) {
        calcValue = calcValue * parseFloat(pumpOutCycle);
        const hasFryer = selectedAppliances.includes("fryer");
        const hasFoodWaste = selectedAppliances.includes("food_waste_disposal");
        let breakdownStr = `${calculatedMeals} (Meals) × ${prodRate} (LBS) × ${pumpOutCycle} (Cycles)`;
        if (hasFryer && hasFoodWaste) { calcValue = calcValue / 0.67; breakdownStr += ` ÷ 0.67 (Fryer & Food Waste)`; }
        else if (hasFoodWaste && !hasFryer) { calcValue = calcValue / 3; breakdownStr += ` ÷ 3 (Food Waste Only)`; }
        setCalculatedGreaseCost(calcValue);
        setCalculationBreakdown(breakdownStr);
      }
    } else { setCalculatedGreaseCost(0); setCalculationBreakdown(""); }
  }, [calculatedMeals, selectMenu, selectedServeWare, pumpOutCycle, selectedAppliances]);

  useEffect(() => {
    const sqf = parseFloat(sqfBuilding);
    const dining = parseFloat(diningAreaPercentage);
    const perPerson = parseFloat(sqfPerPerson);
    const turns = parseFloat(turnsPerSeat);
    if (!isNaN(sqf) && !isNaN(dining) && !isNaN(perPerson) && perPerson > 0) {
      const seats = ((sqf * dining) / 100) / perPerson;
      if (!isNaN(turns)) {
        const totalMeals = Math.round(seats * turns);
        setInputValue(totalMeals.toString());
        setValue("mealType.value", totalMeals, { shouldValidate: true });
        setValue("mealType.type", "Meals per day", { shouldValidate: true });
        setCalculatedMeals(totalMeals);
      }
    }
  }, [sqfBuilding, diningAreaPercentage, sqfPerPerson, turnsPerSeat, mealData, setValue]);

  const handlePrevious = async () => { await loadStepData(3, true); onPrev(); };

  const handleBtn = async (formData) => {
    if (!projectId) { toast.error("Project ID not found. Please restart the process from Step 1."); return; }
    setLoading(true);
    try {
      const apiData = transformStepFourData(formData, selectMenu, calculatedMeals, calculatedGreaseCost, selectedServeWare, { sqfBuilding, diningAreaPercentage, sqfPerPerson, turnsPerSeat, pumpOutCycle });
      const response = await API.updateCalculatorConfiguration(projectId, apiData, token);
      if (response && response.success) { toast.success(response.message || "Grease capacity information saved successfully!"); onNext(); }
      else toast.error(response?.message || "Failed to save grease capacity information. Please try again.");
    } catch (error) { toast.error("An error occurred while saving grease capacity information. Please try again."); }
    finally { setLoading(false); }
  };

  const handleInputChange = (e) => {
    const value = parseFloat(e.target.value);
    setInputValue(value);
    setValue("mealType.value", value, { shouldValidate: true });
    setValue("mealType.type", "Meals per day", { shouldValidate: true });
    let mealsPerDay = value;
    if (mealData && mealData.calculation) mealsPerDay = mealData.calculation(value);
    setCalculatedMeals(mealsPerDay);
  };

  useEffect(() => {
    if (existingData) {
      const formData = reverseTransformStepFourData(existingData, menuList);
      reset({ appliances: formData.appliances || [], flatware: formData.flatware || "true", bestDescribe: formData.bestDescribe || "", mealType: formData.mealType || { type: "Meals per day", value: formData.calculatedMeals || 0 }, sqfBuilding: formData.sqfBuilding || "", diningAreaPercentage: formData.diningAreaPercentage || "", sqfPerPerson: formData.sqfPerPerson || "", turnsPerSeat: formData.turnsPerSeat || "", pumpOutCycle: formData.pumpOutCycle || "" });
      if (formData.selectedMenu) setSelectMenu(formData.selectedMenu);
      if (formData.selectedMealData) setMealData(formData.selectedMealData);
      else if (formData.mealType?.type) { const foundMeal = mealList.find((meal) => meal.title === formData.mealType.type); setMealData(foundMeal || mealList[0]); }
      else setMealData(mealList[0]);
      const mealValue = formData.mealType?.value || formData.calculatedMeals || 0;
      setInputValue(mealValue.toString());
      if (formData.selectedServeWare) setSelectedServeWare(formData.selectedServeWare);
      if (formData.calculatedMeals) setCalculatedMeals(formData.calculatedMeals);
      else if (mealValue > 0) setCalculatedMeals(mealValue);
      if (formData.calculatedGreaseCost) setCalculatedGreaseCost(formData.calculatedGreaseCost);
    }
  }, [existingData, reset, menuList]);

  useEffect(() => {
    const fetchMenuItems = async () => {
      setIsLoadingMenu(true);
      try {
        const response = await API.fetchListingDataMenuitems();
        if (response && response?.success && response?.data) {
          setMenuList(response?.data?.map((item) => ({
            title: item.name,
            label: item.description,
            type: item.tag,
            image: item.image || null
          })));
        } else { toast.error("Failed to load menu items"); setMenuList([]); }
      } catch (error) { toast.error("Error loading menu items from server"); setMenuList([]); }
      finally { setIsLoadingMenu(false); }
    };
    fetchMenuItems();
  }, []);

  return (
    <div className="stepWrap">
      <div className="stepWrap__header">
        <div className="stepWrap__headerLeft">
          <h2>Grease Capacity Calculation</h2>
        </div>
        <span className="asmeTag">ASME Sizing Guidelines</span>
      </div>

      <div className="row">
        <div className="col-6">
          <CheckboxGroup name="appliances" label="What is in the kitchen?" control={control}
            options={[{ label: "Fryer", value: "fryer" }, { label: "Food Waste Disposal", value: "food_waste_disposal" }]} />
        </div>
        <div className="col-6">
          <RadioGroup name="flatware" control={control} defaultValue="true" label="What kind of dishes are used? *"
            options={serveWare} rules={{ required: "Please select a trap location." }}
            onChange={(value) => { const fullObject = serveWare.find((item) => item.value === value); setSelectedServeWare(fullObject); }} />
        </div>

        <div className="col-12">
          <div className="form-group">
            <label className="title">What kind of restaurant is the interceptor serving? *</label>
            <div className="selectWrap">
              <div className="form-control custom-select"
                style={{
                  fontWeight: selectMenu ? "700" : "normal",
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  height: 'auto',
                  minHeight: '45px'
                }}
                onClick={() => setShowMenu(!showMenu)}>
                {selectMenu ? (
                  <>
                    {selectMenu.image && (
                      <img src={`${process.env.REACT_APP_IMAGE_BASEURL?.replace(/\/product-image\/?$/, "")}/${selectMenu.image}`}
                        alt=""
                        style={{ width: '24px', height: '24px', borderRadius: '50%', objectFit: 'contain' }}
                      />
                    )}
                    <span>{selectMenu.title}</span>
                  </>
                ) : (
                  "Select"
                )}
              </div>
              {showMenu && (
                <div className="dropdownMenu">
                  {menuList?.map((item, idx) => (
                    <div key={`menu__${idx}`} className={`dropdownMenu__item ${selectMenu === item ? "active" : null}`}
                      onClick={() => { setSelectMenu(item); setShowMenu(false); setValue("bestDescribe", item.title); }}
                      style={{ padding: '12px 15px' }}>
                      <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                        <div className="menu-circle-icon" style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          overflow: 'hidden',
                          flexShrink: 0,
                          background: '#f3f4f6',
                          border: '1px solid #e5e7eb',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          {item.image ? (
                            <img src={`${process.env.REACT_APP_IMAGE_BASEURL?.replace(/\/product-image\/?$/, "")}/${item.image}`} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                          ) : (
                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#6b7280' }}>
                              {item.title.substring(0, 1).toUpperCase()}
                            </span>
                          )}
                        </div>
                        <div style={{ flex: 1 }}>
                          <div className="head">
                            <label style={{ margin: 0, fontWeight: '700' }}>{item.title}</label>
                            <small className={item.type}>{item.type} Grease</small>
                          </div>
                          {item.label && <span style={{ fontSize: '13px', color: '#666', marginTop: '4px', display: 'block' }}>{item.label}</span>}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {formState?.errors?.bestDescribe?.message && <span className="error">{formState.errors.bestDescribe.message}</span>}
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="row" style={{ marginBottom: "15px" }}>
            <div className="col-4">
              <div className="form-group">
                <label className="title" style={{ fontSize: "14px", marginBottom: "8px" }}>Square Feet of building:</label>
                <input type="number" className="form-control" {...register("sqfBuilding")} placeholder="SQF value" />
                {formState?.errors?.sqfBuilding?.message && <span className="error" style={{ display: "block", marginTop: "5px" }}>{formState.errors.sqfBuilding.message}</span>}
              </div>
            </div>
            <div className="col-4">
              <div className="form-group">
                <label className="title" style={{ fontSize: "14px", marginBottom: "8px" }}>Dining Area Percentage:</label>
                <input type="number" className="form-control" {...register("diningAreaPercentage")} placeholder="% Value" />
                {formState?.errors?.diningAreaPercentage?.message && <span className="error" style={{ display: "block", marginTop: "5px" }}>{formState.errors.diningAreaPercentage.message}</span>}
              </div>
            </div>
            <div className="col-4">
              <div className="form-group">
                <label className="title" style={{ fontSize: "14px", marginBottom: "8px" }}>SQF/Person:</label>
                <input type="number" className="form-control" {...register("sqfPerPerson")} placeholder="People per SQF" />
                {formState?.errors?.sqfPerPerson?.message && <span className="error" style={{ display: "block", marginTop: "5px" }}>{formState.errors.sqfPerPerson.message}</span>}
              </div>
            </div>
          </div>

          {sqfBuilding && diningAreaPercentage && sqfPerPerson && (
            <div className="form-group" style={{ marginTop: "-10px", marginBottom: "15px" }}>
              <p style={{ margin: 0, fontSize: "14px", color: "#333" }}>
                Calculated Number of Seats: <b>{(((parseFloat(sqfBuilding) * parseFloat(diningAreaPercentage)) / 100) / parseFloat(sqfPerPerson)).toFixed(2)}</b>
              </p>
            </div>
          )}

          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <label className="title">Turns per seat:</label>
                <input type="number" className="form-control" {...register("turnsPerSeat")} placeholder="Turns per seat" />
                {formState?.errors?.turnsPerSeat?.message && <span className="error" style={{ display: "block", marginTop: "5px" }}>{formState.errors.turnsPerSeat.message}</span>}
              </div>
            </div>
          </div>

          {sqfBuilding && diningAreaPercentage && sqfPerPerson && turnsPerSeat && (
            <div className="form-group" style={{ marginTop: "-10px", marginBottom: "15px" }}>
              <p style={{ margin: 0, fontSize: "14px", color: "#333" }}>
                Calculated Total Meals: <b>{Math.round((((parseFloat(sqfBuilding) * parseFloat(diningAreaPercentage)) / 100) / parseFloat(sqfPerPerson)) * parseFloat(turnsPerSeat))}</b>
              </p>
            </div>
          )}

          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <label className="title">Please Select Sizing Method *</label>
                <div className="fieldGroup">
                  <div className="customDropdown" style={{ cursor: "default" }}>
                    <button type="button" className="customDropdown__btn" style={{ background: "#f8f9fa", color: "#333", pointerEvents: "none" }}>Meals per day</button>
                  </div>
                  <input type="number" className="form-control" value={inputValue} onChange={handleInputChange} placeholder="Enter meals per day" />
                </div>
                {formState?.errors?.mealType?.type?.message && <span className="error">{formState.errors.mealType?.type?.message}</span>}
                {formState?.errors?.mealType?.value?.message && !formState?.errors?.mealType?.type?.message && <span className="error">{formState.errors.mealType?.value?.message}</span>}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <label className="title">Pump Out Cycles:</label>
                <select className="form-control" {...register("pumpOutCycle")}>
                  <option value="" disabled>Please Select Pump Out Cycles:</option>
                  <option value="30">30 Days</option>
                  <option value="60">60 Days</option>
                  <option value="90">90 Days</option>
                </select>
                {formState?.errors?.pumpOutCycle?.message && <span className="error" style={{ display: "block", marginTop: "5px" }}>{formState.errors.pumpOutCycle.message}</span>}
              </div>
            </div>
          </div>

          {calculatedGreaseCost > 0 && (
            <div className="row" style={{ marginTop: "20px" }}>
              <div className="col-12">
                <div className="stepWrap__greasResult">
                  <h4>Calculated Grease Capacity: <b>{calculatedGreaseCost.toFixed(2)} LBS</b></h4>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="stepWrap__cta">
        <Button white label="Previous" onClick={handlePrevious} disabled={loading} />
        <Button label={loading ? "Saving..." : "Continue"} onClick={handleSubmit(handleBtn)} disabled={loading} />
      </div>
    </div>
  );
};

// ─── STEP FIVE ───────────────────────────────────────────────────────────────
const StepFive = ({ onPrev, onNext, loadStepData, stepData, projectId, token, capacityTypeLabel, isGravity }) => {
  const [summaryData, setSummaryData] = useState({ step1: null, step2: null, step3: null, step4: null });
  const [loading, setLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [productNotFound, setProductNotFound] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setProductNotFound(false);
    if (hasLoaded && projectId) return;
    const loadAllStepData = async () => {
      if (!projectId) { setLoading(false); return; }
      setLoading(true);
      try {
        const [step1Data, step2Data, step3Data, step4Data] = await Promise.all([
          loadStepData(1, true), loadStepData(2, true), loadStepData(3, true), loadStepData(4, true),
        ]);
        setSummaryData({ step1: step1Data, step2: step2Data, step3: step3Data, step4: step4Data });
        setHasLoaded(true);
      } catch (error) {
        toast.error("Failed to load project summary");
        if (stepData[1] && stepData[2] && stepData[3] && stepData[4]) {
          setSummaryData({ step1: stepData[1], step2: stepData[2], step3: stepData[3], step4: stepData[4] });
        }
      } finally { setLoading(false); }
    };
    loadAllStepData();
  }, [projectId]);

  const getFixtureSummary = () => {
    if (!summaryData.step3?.step3?.fixtures) return { count: 0, totalFlowRate: 0 };
    const fixtures = summaryData.step3.step3.fixtures;
    return { count: fixtures.length, totalFlowRate: fixtures.reduce((sum, f) => sum + (parseFloat(f.flowRate) || 0), 0) };
  };

  const getConstructionType = () => {
    if (!summaryData.step1?.step1?.constructionType) return "Not specified";
    const typeMap = { newConstruction: "New Construction", tenantFinish: "Remodel / Tenant Finish", shell: "Shell Space (Unknown Tenant)", interceptorReplacement: "Interceptor Replacement" };
    return typeMap[summaryData.step1.step1.constructionType] || summaryData.step1.step1.constructionType;
  };

  const getLocationInfo = () => {
    if (!summaryData.step2?.step2) return "Not specified";
    const step2 = summaryData.step2.step2;
    return `${step2.greeceInterceptorLocation === "indoors" ? "Indoors" : "Outdoors"}, ${step2.willBurried ? "Buried" : "Not Buried"}`;
  };

  const getPipeConnection = () => !summaryData.step3?.step3?.drainagePipeSize ? "Not specified" : `${summaryData.step3.step3.drainagePipeSize}" Pipe`;

  const getGreaseCapacity = () => {
    if (!summaryData.step4?.step4) return { menu: "Not specified", menuValue: 0, lbs: 0 };
    const step4 = summaryData.step4.step4;
    return { menu: step4.menu || "Not specified", menuValue: step4.menuValue || 0, lbs: step4.lbs || 0 };
  };

  const handleCreateProject = async () => {
    if (!projectId) { toast.error("Project ID not found. Please restart the process from Step 1."); return; }
    setCreateLoading(true);
    setProductNotFound(false);
    try {
      const response = await API.getMatchedProduct(projectId, token);
      if (response && response.success) {
        toast.success(response.message);
        navigate("/project-results", {
          state: {
            productId: response.data?.primaryProduct?._id,
            secondaryProductId: response.data?.secondaryProduct?._id,
            matchedProducts: response.data?.primaryProduct,
            projectId,
            projectAddress: summaryData.step1?.step1?.address
              ? `${summaryData.step1.step1.address.street}, ${summaryData.step1.step1.address.city}, ${summaryData.step1.step1.address.state} ${summaryData.step1.step1.address.zip} ${summaryData.step1.step1.address.country}`
              : "Address not available",
            constructionType: summaryData.step1?.step1?.constructionType ? getConstructionType() : "Not specified",
            steponeDetails: summaryData.step1?.step1,
          },
        });
      } else {
        const errorMsg = response?.message || "";
        if (errorMsg.toLowerCase().includes("product not found")) {
          setProductNotFound(true);
        }
        toast.error(errorMsg || "Failed to create project and find matched products.");
      }
    } catch (error) { toast.error("An error occurred while creating the project. Please try again."); }
    finally { setCreateLoading(false); }
  };

  if (loading) {
    return (
      <div className="stepWrap">
        <div className="stepWrap__header"><div className="stepWrap__headerLeft"><h2>Gathering Requirement For Your Project</h2><p>We're reviewing the provided information...</p></div></div>
        <div style={{ display: "flex", justifyContent: "center", padding: "50px" }}><ClipLoader color="#0070C0" size={50} /></div>
      </div>
    );
  }

  const fixtureSummary = getFixtureSummary();

  return (
    <div className="stepWrap">
      <div className="stepWrap__header">
        <div className="stepWrap__headerLeft">
          <h2>Gathering Requirement For Your Project</h2>
          <p>We're reviewing the provided location information.</p>
        </div>
      </div>

      <div className="row">
        <div className={isGravity ? "col-6" : "col-4"}>
          <div className="reviewBox">
            <span><IoLocation /></span>
            <h5>Interceptor Information</h5>
            <ul>
              <li><IoMdCheckmark /> {getConstructionType()}</li>
              <li><IoMdCheckmark /> {getLocationInfo()}</li>
            </ul>
          </div>
        </div>
        <div className={isGravity ? "col-6" : "col-4"}>
          <div className="reviewBox">
            <span><BiGridAlt /></span>
            <h5>Fixture Information</h5>
            <ul>
              <li><IoMdCheckmark /> {getPipeConnection()}</li>
              <li>
                <IoMdCheckmark /> {fixtureSummary.count} Fixtures
                {fixtureSummary.totalFlowRate > 0 && (
                  <small style={{ display: "block", marginTop: "4px", color: "#666" }}>Total Flow Rate: {fixtureSummary.totalFlowRate.toFixed(2)} GPM</small>
                )}
              </li>
            </ul>
          </div>
        </div>
        {!isGravity && (
          <div className="col-4">
            <div className="reviewBox">
              <span><MdOutlineFastfood /></span>
              <h5>{capacityTypeLabel || "Capacity"}</h5>
              <ul>
                <li><IoMdCheckmark /> {getGreaseCapacity().menu}</li>
                <li>
                  <IoMdCheckmark /> {getGreaseCapacity().menuValue} meals/day
                  {getGreaseCapacity().lbs > 0 && (
                    <small style={{ display: "block", marginTop: "4px", color: "#666" }}>LBS: {getGreaseCapacity().lbs.toFixed(2)}</small>
                  )}
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>

      {productNotFound && (
        <div className="stepWrap__productNotFound" style={{
          marginTop: '30px',
          background: '#ffffff',
          border: '1px solid #bbdefb',
          borderRadius: '8px',
          padding: '24px',
          boxShadow: '0 2px 8px rgba(1, 84, 160, 0.08)',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <h4 style={{ color: '#0154A0', margin: 0, fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FaInfoCircle style={{ color: '#0154A0' }} /> Product Not Found
            </h4>
            <p style={{ margin: 0, color: '#333333', fontSize: '15px', lineHeight: '1.5' }}>
              We could not find a matching product based on your sizing inputs. Please contact MIFAB for more details or custom assistance.
            </p>
          </div>

          <div style={{
            background: '#0756A2',
            padding: '16px 24px',
            borderRadius: '6px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}>
            <h5 style={{ color: '#ffffff', margin: 0, fontSize: '16px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              CONTACT US
            </h5>
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              columnGap: '32px',
              rowGap: '8px',
              fontSize: '15px',
              color: '#ffffff'
            }}>
              <div>
                <span style={{ fontWeight: '700' }}>Toll Free:</span>{' '}
                <a href="tel:1-800-465-2736" style={{ color: '#ffffff', textDecoration: 'none' }}>800.465.2736</a>
              </div>
              <div>
                <span style={{ fontWeight: '700' }}>Tel:</span>{' '}
                <a href="tel:773-341-3030" style={{ color: '#ffffff', textDecoration: 'none' }}>773.341.3030</a>
              </div>
              <div>
                <span style={{ fontWeight: '700' }}>Fax:</span>{' '}
                <span style={{ color: '#ffffff' }}>773.341.3047</span>
              </div>
              <div>
                <span style={{ fontWeight: '700' }}>E-mail:</span>{' '}
                <a href="mailto:sales@mifab.com" style={{ color: '#ffffff', textDecoration: 'none' }}>sales@mifab.com</a>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="stepWrap__cta">
        <Button white label="Previous" onClick={onPrev} />
        <Button label={createLoading ? "Creating Project..." : "Create Project"} onClick={handleCreateProject} disabled={createLoading} />
      </div>
    </div>
  );
};

// ─── CREATE PROJECT FORM (MAIN) ───────────────────────────────────────────────
const CreateProjectForm = () => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [projectId, setProjectId] = useState(null);
  const [stepData, setStepData] = useState({});
  const [loading, setLoading] = useState(false);
  const [asmeSizingMode, setAsmeSizingMode] = useState(true);
  const [formValidations, setFormValidations] = useState({ step1: false, step2: false, step3: false, step4: false });
  const [capacityTypeLabel, setCapacityTypeLabel] = useState("Capacity");
  const [capacityList, setCapacityList] = useState([]);
  const [interceptorType, setInterceptorType] = useState("hydromechanical");

  const isGravity = interceptorType === "gravity";

  const TAB_INDICES = isGravity
    ? { ABOUT: 0, LOCATION: 1, FIXTURES: 2, SUMMARY: 3 }
    : { ABOUT: 0, LOCATION: 1, FIXTURES: 2, GREASE_CAPACITY: 3, SUMMARY: 4 };

  const tabList = isGravity
    ? [
      { label: "Project Details", icon: "/images/projectlayout.png" },
      { label: "Installation", icon: "/images/map-pin.png" },
      { label: "Fixtures", icon: "/images/tap.png" },
      { label: "Results", icon: "/images/analytics.png" }
    ]
    : [
      { label: "Project Details", icon: "/images/projectlayout.png" },
      { label: "Installation", icon: "/images/map-pin.png" },
      { label: "Fixtures", icon: "/images/tap.png" },
      { label: "Sizing Inputs", icon: "/images/checklist.png" },
      { label: "Results", icon: "/images/analytics.png" }
    ];

  const activeIndex = currentTabIndex;

  const { state } = useLocation();
  const { token: authToken } = useAuthContext();
  const token = authToken || "GUEST";

  const canNavigateToStep = (stepIndex) => {
    if (stepIndex < activeIndex) return true;
    for (let i = 0; i < stepIndex; i++) { if (!formValidations[`step${i + 1}`]) return false; }
    return true;
  };

  const updateFormValidation = (stepNumber, isValid) => {
    setFormValidations((prev) => ({ ...prev, [`step${stepNumber}`]: isValid }));
  };

  const loadStepData = async (step, forceRefresh = false) => {
    if (!projectId) return null;
    if (forceRefresh || !stepData[step]) {
      try {
        const response = await API.getCalculatorConfiguration(projectId, step, token);
        if (response && response.success) { setStepData((prev) => ({ ...prev, [step]: response.data })); return response.data; }
        return null;
      } catch (error) { toast.error(`Failed to load existing data for step ${step}`); return null; }
    }
    return stepData[step];
  };

  const getIndexFromTabName = (tabName) => {
    const nameToIndex = { "About": 0, "Location": 1, "Fixtures": 2, "Grease Capacity": 3, "Capacity": 3, "Liquid Capacity": 3, "Sludge Capacity": 3, "Grease": 3, "Lint": 3, "Summary": 4 };
    return nameToIndex[tabName] ?? 0;
  };

  useEffect(() => {
    const fetchCapacity = async () => {
      try {
        let response = await API.ProductCategoryListing();
        if (response?.data) {
          setCapacityList(response?.data?.filter((item) => item?.status === 1)?.map((item) => ({ id: item?._id, value: item?._id, name: item?.title })));
        }
      } catch (error) { toast.error("Failed to load capacity types"); }
    };
    if (capacityList.length === 0) fetchCapacity();
  }, []);

  useEffect(() => {
    if (state?.data && state?.projectId) {
      setProjectId(state.projectId);
      if (state.targetTab) setCurrentTabIndex(getIndexFromTabName(state.targetTab));
      if (state.configurationData) {
        const config = state.configurationData;
        const newStepData = {};
        if (config.step1) newStepData[1] = config;
        if (config.step2) newStepData[2] = config;
        if (config.step3) newStepData[3] = config;
        if (config.step4) newStepData[4] = config;
        setStepData(newStepData);
        const lastStep = parseInt(state.lastCompletedStep.replace("step", ""));
        const newValidations = {};
        for (let i = 1; i <= lastStep; i++) newValidations[`step${i}`] = true;
        setFormValidations(newValidations);
      }
    }
  }, [state]);

  useEffect(() => {
    if (!stepData[2]) return;
    const step2 = stepData[2]?.step2 || stepData[2];
    if (step2?.interceptorType) setInterceptorType(step2.interceptorType);
  }, [stepData[2]]);

  useEffect(() => {
    if (capacityList.length === 0 || !stepData[2]) return;
    const step2Data = stepData[2]?.step2 || stepData[2];
    const savedCapacityType = step2Data?.capacityType;
    if (!savedCapacityType) return;
    const found = capacityList.find((item) => item.value === savedCapacityType);
    if (!found) return;
    const name = found.name?.toLowerCase() || "";
    if (name.includes("liquid")) setCapacityTypeLabel("Liquid Capacity");
    else if (name.includes("sludge")) setCapacityTypeLabel("Sludge Capacity");
    else if (name.includes("grease")) setCapacityTypeLabel("Grease Capacity");
    else setCapacityTypeLabel(found.name || "Capacity");
  }, [capacityList, stepData[2]]);

  return (
    <div className="crtePrjct">
      {/* ── Layout: sidebar + content ── */}
      <div className="crtePrjct__layout">
        {/* Sidebar */}
        <aside className="crtePrjct__sidebar">
          <nav className="crtePrjct__sideNav">
            {tabList.map((item, idx) => {
              const isActive = currentTabIndex === idx;
              const isDone = idx < activeIndex || formValidations[`step${idx + 1}`];
              const canNavigate = canNavigateToStep(idx);
              return (
                <React.Fragment key={`sidenav__${idx}`}>
                  <div
                    className={`crtePrjct__sideNavItem ${isActive ? "crtePrjct__sideNavItem--active" : ""} ${isDone && !isActive ? "crtePrjct__sideNavItem--done" : ""} ${!canNavigate ? "crtePrjct__sideNavItem--disabled" : ""}`}
                    onClick={async () => {
                      if (!loading && canNavigate) {
                        if (idx < 4 && projectId) await loadStepData(idx + 1, true);
                        setCurrentTabIndex(idx);
                      } else if (!canNavigate) {
                        toast.error(`Please complete the previous steps first`);
                      }
                    }}
                    style={{ cursor: canNavigate ? "pointer" : "not-allowed" }}
                  >
                    <span className="crtePrjct__sideNavNum">
                      <img src={item.icon} alt="" className="crtePrjct__sideNavIcon" />
                    </span>
                    <span className="crtePrjct__sideNavLabel">{item.label}</span>
                  </div>
                  {idx < tabList.length - 1 && <div className="crtePrjct__sideNavLine" />}
                </React.Fragment>
              );
            })}
          </nav>
          <div className="crtePrjct__sideHelp">
            <p>Need Help?</p>
            <span className="crtePrjct__sideHelpItem">
              <FaPhoneAlt className="crtePrjct__sideHelpIcon" />
              1-800-465-2736
            </span>
            <span className="crtePrjct__sideHelpItem">
              <FaEnvelope className="crtePrjct__sideHelpIcon" />
              info@mifab.com
            </span>
          </div>
        </aside>

        {/* Main content */}
        <main className="crtePrjct__main">
          <div className="crtePrjct__topBar">
            <h4 className="crtePrjct__topBarTitle">INTERCEPTOR SIZING TOOL</h4>
            <div className="crtePrjct__topBarMode">
              <span>ASME Sizing Mode</span>
              <label className="crtePrjct__asmeSwitch" aria-label="ASME Sizing Mode">
                <input
                  type="checkbox"
                  checked={asmeSizingMode}
                  onChange={(e) => setAsmeSizingMode(e.target.checked)}
                  role="switch"
                  aria-checked={asmeSizingMode}
                />
                <span className="crtePrjct__asmeSlider" />
              </label>
            </div>
          </div>
          {currentTabIndex === TAB_INDICES.ABOUT && (
            <StepOne onNext={() => { updateFormValidation(1, true); setCurrentTabIndex(TAB_INDICES.LOCATION); }}
              loading={loading} setLoading={setLoading} setProjectId={setProjectId} token={token} existingData={stepData[1]} projectId={projectId} />
          )}
          {currentTabIndex === TAB_INDICES.LOCATION && (
            <StepTwo onPrev={() => setCurrentTabIndex(TAB_INDICES.ABOUT)}
              onNext={() => { updateFormValidation(2, true); setCurrentTabIndex(TAB_INDICES.FIXTURES); }}
              loading={loading} setLoading={setLoading} projectId={projectId} token={token} existingData={stepData[2]}
              loadStepData={loadStepData} onCapacityTypeChange={(label) => setCapacityTypeLabel(label)}
              onInterceptorTypeChange={(type) => setInterceptorType(type)} capacityList={capacityList} setCapacityList={setCapacityList} />
          )}
          {currentTabIndex === TAB_INDICES.FIXTURES && (
            <StepThree onPrev={() => setCurrentTabIndex(TAB_INDICES.LOCATION)}
              onNext={() => { updateFormValidation(3, true); if (isGravity) { updateFormValidation(4, true); setCurrentTabIndex(TAB_INDICES.SUMMARY); } else setCurrentTabIndex(TAB_INDICES.GREASE_CAPACITY); }}
              loading={loading} setLoading={setLoading} projectId={projectId} token={token} existingData={stepData[3]}
              loadStepData={loadStepData} capacityTypeLabel={capacityTypeLabel} />
          )}
          {!isGravity && currentTabIndex === TAB_INDICES.GREASE_CAPACITY && (
            <StepFour onPrev={() => setCurrentTabIndex(TAB_INDICES.FIXTURES)}
              onNext={() => { updateFormValidation(4, true); setCurrentTabIndex(TAB_INDICES.SUMMARY); }}
              loading={loading} setLoading={setLoading} projectId={projectId} token={token} existingData={stepData[4]}
              loadStepData={loadStepData} capacityTypeLabel={capacityTypeLabel} />
          )}
          {currentTabIndex === TAB_INDICES.SUMMARY && (
            <StepFive onPrev={() => { if (isGravity) setCurrentTabIndex(TAB_INDICES.FIXTURES); else setCurrentTabIndex(TAB_INDICES.GREASE_CAPACITY); }}
              onNext={() => toast("Wow so easy! Ready to Create")}
              loadStepData={loadStepData} stepData={stepData} projectId={projectId} token={token}
              capacityTypeLabel={capacityTypeLabel} isGravity={isGravity} />
          )}
        </main>
      </div>
    </div>
  );
};

export default CreateProjectForm;